import {
  JsonToBoolean,
  JsonToDouble,
  JsonToInt32,
  JsonToInt64,
  JsonToString,
  JsonToList,
  ArrayToJson,
  JsonToMap,
  MapToJson,
} from '../Helper/Converter';
class SpawnWave_DeprecatedLanesEntry {
  get descriptor() {
    return SpawnWave_DeprecatedLanesEntry.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasKey = false;
    this._key = null;
    this._hasValue = false;
    this._value = null;
  }
  isEmpty() {
    if (this._hasKey) return false;
    if (this._hasValue && !this._value.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof SpawnWave_DeprecatedLanesEntry) {
      return value;
    }
    return SpawnWave_DeprecatedLanesEntry.fromJson(value);
  }
  static fromJson(json) {
    const result = new SpawnWave_DeprecatedLanesEntry();
    if (json.key != null) {
      result._hasKey = true;
      result._key = JsonToString.fromJson(json.key);
    }
    if (json.value != null) {
      result._hasValue = true;
      result._value = SpawnLane.fromJson(json.value);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasKey) {
      result.key = JsonToString.toJson(this._key);
    }
    if (this._hasValue && !this._value.isEmpty()) {
      result.value = SpawnLane.toJson(this._value);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get key() {
    return this._hasKey ? this._key : JsonToString.default;
  }
  get hasKey() {
    return this._hasKey;
  }
  setKey(path, value) {
    return {type: 'SET', path: path.concat(['key']), value};
  }
  deleteKey(path) {
    return {type: 'DELETE', path: path.concat(['key'])};
  }
  /**
   * @returns {SpawnLane}
   */
  get value() {
    return this._hasValue ? this._value : SpawnLane.default;
  }
  get hasValue() {
    return this._hasValue;
  }
  setValue(path, value) {
    return {type: 'SET', path: path.concat(['value']), value: value.toJson()};
  }
  deleteValue(path) {
    return {type: 'DELETE', path: path.concat(['value'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "key": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SpawnWave_DeprecatedLanesEntry(this);
              copy._hasKey = true;
              copy._key = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKey) {
                return this;
              }
              const copy = new SpawnWave_DeprecatedLanesEntry(this);
              copy._hasKey = false;
              copy._key = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "value": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SpawnWave_DeprecatedLanesEntry(this);
              copy._hasValue = true;
              copy._value = SpawnLane.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasValue) {
                return this;
              }
              const copy = new SpawnWave_DeprecatedLanesEntry(this);
              copy._hasValue = false;
              copy._value = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasValue) {
            const copy = new SpawnWave_DeprecatedLanesEntry(this);
            copy._hasValue = true;
            copy._value = SpawnLane.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._value.apply(type, path.slice(1), value);
          if (newValue === this._value) {
            return this;
          }
          const copy = new SpawnWave_DeprecatedLanesEntry(this);
          copy._value = copy._value.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {SpawnWave_DeprecatedLanesEntry} other
   * @returns {SpawnWave_DeprecatedLanesEntry}
   */
  merge(other) {
    const copy = new SpawnWave_DeprecatedLanesEntry(this);
    if (other._hasKey) {
      copy._hasKey = true;
      copy._key = other._key;
    }
    if (other._hasValue) {
      if (copy._hasValue) {
        copy._value = copy.value.merge(other.value);
      } else {
        copy._value = other._value;
      }
      copy._hasValue = true;
    }
    return copy;
  }
}
SpawnWave_DeprecatedLanesEntry.default = new SpawnWave_DeprecatedLanesEntry();
class SpawnWave_DeprecatedLanesEntry_Builder {
  constructor(value) {
    this._value = new SpawnWave_DeprecatedLanesEntry(value);
  }
  build() {
    return new SpawnWave_DeprecatedLanesEntry(this._value);
  }
  setKey(value) {
    this._value._hasKey = true;
    this._value._key = value;
    return this;
  }
  deleteKey() {
    this._value._hasKey = false;
    this._value._key = null;
    return this;
  }
  setValue(value) {
    this._value._hasValue = true;
    this._value._value = value;
    return this;
  }
  deleteValue() {
    this._value._hasValue = false;
    this._value._value = null;
    return this;
  }
}
SpawnWave_DeprecatedLanesEntry.Builder = SpawnWave_DeprecatedLanesEntry_Builder;
class SpawnWave_DeprecatedLanesEntry_WithParent {
  /**
   * @param {SpawnWave_DeprecatedLanesEntry} value
   * @param {SpawnWave_DeprecatedLanesEntry_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return SpawnWave_DeprecatedLanesEntry.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasKey() {
    if (this._cachedHasKey === undefined) {
      if (this._value.hasKey) {
        this._cachedHasKey = true;
      } else {
        this._cachedHasKey = this._parent ? this._parent.hasKey : false;
      }
    }
    return this._cachedHasKey;
  }
  get key() {
    if (this._cachedKey === undefined) {
      if (this._value.hasKey) {
        this._cachedKey = this._value.key;
      } else {
        this._cachedKey = this._parent ? this._parent.key : this._value.key;
      }
    }
    return this._cachedKey;
  }
  get hasValue() {
    if (this._cachedHasValue === undefined) {
      if (this._value.hasValue) {
        this._cachedHasValue = true;
      } else {
        this._cachedHasValue = this._parent ? this._parent.hasValue : false;
      }
    }
    return this._cachedHasValue;
  }
  get value() {
    if (!this._cachedValue) {
      if (this._value.hasValue) {
        this._cachedValue = new SpawnLane.WithParent(this._value.value, this._parent && this._parent.hasValue ? this._parent.value : null);
      } else {
        this._cachedValue = this._parent ? new SpawnLane.WithParent(SpawnLane.default, this._parent.value) : SpawnLane.WithParent.default;
      }
    }
    return this._cachedValue;
  }
  update(current, parent) {
    const result = new SpawnWave_DeprecatedLanesEntry_WithParent(current, parent);
    if (this._cachedValue && this._value.hasValue && current.hasValue) {
      if (this._value.value === current.value && this._parent === parent) {
        result._cachedValue = this._cachedValue;
      } else {
        result._cachedValue = this._cachedValue.update(current.value, parent && parent.hasValue ? parent.value : null);
      }
    }
    return result;
  }
}
SpawnWave_DeprecatedLanesEntry_WithParent.default = new SpawnWave_DeprecatedLanesEntry_WithParent(SpawnWave_DeprecatedLanesEntry.default, null);
SpawnWave_DeprecatedLanesEntry.WithParent = SpawnWave_DeprecatedLanesEntry_WithParent;
class SpawnWave_DeprecatedLanesEntry_Descriptor {
  get key() {
    if (!this._key) {
      this._key = {
        name: "key",
        Name: "Key",
        number: 1,
        protoType: 9,
        protoName: "key",
        type: JsonToString,
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._key;
  }
  get value() {
    if (!this._value) {
      this._value = {
        name: "value",
        Name: "Value",
        number: 2,
        protoType: 11,
        protoName: "value",
        type: SpawnLane,
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._value;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.key,
        this.value,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
SpawnWave_DeprecatedLanesEntry.descriptor = new SpawnWave_DeprecatedLanesEntry_Descriptor();
export class SpawnWave {
  get descriptor() {
    return SpawnWave.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasDisabled = false;
    this._disabled = null;
    this._hasTotalGold = false;
    this._totalGold = null;
    this._hasBonusGold = false;
    this._bonusGold = null;
    this._hasStartDelay = false;
    this._startDelay = null;
    this._hasCallWaveCountdown = false;
    this._callWaveCountdown = null;
    this._lanes = {};
    this._spawnLanes = [];
  }
  isEmpty() {
    if (this._hasDisabled) return false;
    if (this._hasTotalGold) return false;
    if (this._hasBonusGold) return false;
    if (this._hasStartDelay) return false;
    if (this._hasCallWaveCountdown) return false;
    if (Object.keys(this._lanes).length > 0) return false;
    if (this._spawnLanes.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof SpawnWave) {
      return value;
    }
    return SpawnWave.fromJson(value);
  }
  static fromJson(json) {
    const result = new SpawnWave();
    if (json.disabled != null) {
      result._hasDisabled = true;
      result._disabled = JsonToBoolean.fromJson(json.disabled);
    }
    if (json.totalGold != null) {
      result._hasTotalGold = true;
      result._totalGold = JsonToInt32.fromJson(json.totalGold);
    }
    if (json.bonusGold != null) {
      result._hasBonusGold = true;
      result._bonusGold = JsonToInt32.fromJson(json.bonusGold);
    }
    if (json.startDelay != null) {
      result._hasStartDelay = true;
      result._startDelay = JsonToDouble.fromJson(json.startDelay);
    }
    if (json.callWaveCountdown != null) {
      result._hasCallWaveCountdown = true;
      result._callWaveCountdown = JsonToDouble.fromJson(json.callWaveCountdown);
    }
    result._lanes = JsonToMap(json.lanes, JsonToString, SpawnLane);
    result._spawnLanes = JsonToList(json.spawnLanes, SpawnLane);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasDisabled) {
      result.disabled = JsonToBoolean.toJson(this._disabled);
    }
    if (this._hasTotalGold) {
      result.totalGold = JsonToInt32.toJson(this._totalGold);
    }
    if (this._hasBonusGold) {
      result.bonusGold = JsonToInt32.toJson(this._bonusGold);
    }
    if (this._hasStartDelay) {
      result.startDelay = JsonToDouble.toJson(this._startDelay);
    }
    if (this._hasCallWaveCountdown) {
      result.callWaveCountdown = JsonToDouble.toJson(this._callWaveCountdown);
    }
    if (Object.keys(this._lanes).length > 0) {
      result.lanes = MapToJson(this._lanes, JsonToString, SpawnLane);
    }
    if (this._spawnLanes.length > 0) {
      result.spawnLanes = ArrayToJson(this._spawnLanes, SpawnLane);
    }
    return result;
  }
  /**
   * @returns {boolean}
   */
  get disabled() {
    return this._hasDisabled ? this._disabled : JsonToBoolean.default;
  }
  get hasDisabled() {
    return this._hasDisabled;
  }
  setDisabled(path, value) {
    return {type: 'SET', path: path.concat(['disabled']), value};
  }
  deleteDisabled(path) {
    return {type: 'DELETE', path: path.concat(['disabled'])};
  }
  /**
   * @returns {number}
   */
  get totalGold() {
    return this._hasTotalGold ? this._totalGold : JsonToInt32.default;
  }
  get hasTotalGold() {
    return this._hasTotalGold;
  }
  setTotalGold(path, value) {
    return {type: 'SET', path: path.concat(['totalGold']), value};
  }
  deleteTotalGold(path) {
    return {type: 'DELETE', path: path.concat(['totalGold'])};
  }
  /**
   * @returns {number}
   */
  get bonusGold() {
    return this._hasBonusGold ? this._bonusGold : JsonToInt32.default;
  }
  get hasBonusGold() {
    return this._hasBonusGold;
  }
  setBonusGold(path, value) {
    return {type: 'SET', path: path.concat(['bonusGold']), value};
  }
  deleteBonusGold(path) {
    return {type: 'DELETE', path: path.concat(['bonusGold'])};
  }
  /**
   * @returns {number}
   */
  get startDelay() {
    return this._hasStartDelay ? this._startDelay : JsonToDouble.default;
  }
  get hasStartDelay() {
    return this._hasStartDelay;
  }
  setStartDelay(path, value) {
    return {type: 'SET', path: path.concat(['startDelay']), value};
  }
  deleteStartDelay(path) {
    return {type: 'DELETE', path: path.concat(['startDelay'])};
  }
  /**
   * @returns {number}
   */
  get callWaveCountdown() {
    return this._hasCallWaveCountdown ? this._callWaveCountdown : JsonToDouble.default;
  }
  get hasCallWaveCountdown() {
    return this._hasCallWaveCountdown;
  }
  setCallWaveCountdown(path, value) {
    return {type: 'SET', path: path.concat(['callWaveCountdown']), value};
  }
  deleteCallWaveCountdown(path) {
    return {type: 'DELETE', path: path.concat(['callWaveCountdown'])};
  }
  /**
   * @returns {Object<string, SpawnLane>}
   */
  get lanes() {
    return this._lanes;
  }
  setDeprecatedLanes(path, value) {
    return {type: 'SET', path: path.concat(['lanes']), value: MapToJson(value, JsonToString, SpawnLane)};
  }
  setDeprecatedLanesByKey(path, key, value) {
    return {type: 'SET', path: path.concat(['lanes', key]), value: value.toJson()};
  }
  deleteDeprecatedLanes(path) {
    return {type: 'DELETE', path: path.concat(['lanes'])};
  }
  deleteDeprecatedLanesByKey(path, key) {
    return {type: 'DELETE', path: path.concat(['lanes', key])};
  }
  /**
   * @returns {SpawnLane[]}
   */
  get spawnLanes() {
    return this._spawnLanes;
  }
  addSpawnLanes(path, value) {
    return {type: 'ADD', path: path.concat(['spawnLanes']), value: value.toJson()};
  }
  setSpawnLanes(path, value) {
    return {type: 'SET', path: path.concat(['spawnLanes']), value: ArrayToJson(value, SpawnLane)};
  }
  setSpawnLanesByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['spawnLanes', key]), value: value.toJson()};
  }
  deleteSpawnLanes(path) {
    return {type: 'DELETE', path: path.concat(['spawnLanes'])};
  }
  deleteSpawnLanesByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['spawnLanes', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "disabled": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SpawnWave(this);
              copy._hasDisabled = true;
              copy._disabled = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDisabled) {
                return this;
              }
              const copy = new SpawnWave(this);
              copy._hasDisabled = false;
              copy._disabled = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "totalGold": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SpawnWave(this);
              copy._hasTotalGold = true;
              copy._totalGold = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTotalGold) {
                return this;
              }
              const copy = new SpawnWave(this);
              copy._hasTotalGold = false;
              copy._totalGold = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "bonusGold": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SpawnWave(this);
              copy._hasBonusGold = true;
              copy._bonusGold = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasBonusGold) {
                return this;
              }
              const copy = new SpawnWave(this);
              copy._hasBonusGold = false;
              copy._bonusGold = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "startDelay": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SpawnWave(this);
              copy._hasStartDelay = true;
              copy._startDelay = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasStartDelay) {
                return this;
              }
              const copy = new SpawnWave(this);
              copy._hasStartDelay = false;
              copy._startDelay = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "callWaveCountdown": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SpawnWave(this);
              copy._hasCallWaveCountdown = true;
              copy._callWaveCountdown = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCallWaveCountdown) {
                return this;
              }
              const copy = new SpawnWave(this);
              copy._hasCallWaveCountdown = false;
              copy._callWaveCountdown = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "lanes": {
        if (path.length === 1) {
          switch (type) {
            case 'DELETE': {
              if (Object.keys(this._lanes).length === 0) {
                return this;
              }
              const copy = new SpawnWave(this);
              copy._lanes = {};
              return copy;
            }
            case 'SET': {
              const copy = new SpawnWave(this);
              copy._lanes = {};
              for (let key in value) {
                copy._lanes[key] = SpawnLane.fromAny(value[key]);
              }
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          switch (type) {
            case 'SET': {
              const copy = new SpawnWave(this);
              copy._lanes = {...copy._lanes};
              copy._lanes[path[1]] = SpawnLane.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._lanes[path[1]]) {
                return this;
              }
              const copy = new SpawnWave(this);
              copy._lanes = {...copy._lanes};
              delete copy._lanes[path[1]];
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (this._lanes[key] === undefined) {
            const copy = new SpawnWave(this);
            copy._lanes = {...copy._lanes};
            copy._lanes[key] = SpawnLane.default.apply(type, path.slice(2), value);
            return copy;
          }
          const oldValue = this._lanes[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new SpawnWave(this);
          copy._lanes = {...copy._lanes};
          copy._lanes[key] = newValue;
          return copy;
        }
      }
      case "spawnLanes": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SpawnWave(this);
              copy._spawnLanes = [];        for (let i of value) {
                copy._spawnLanes.push(SpawnLane.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new SpawnWave(this);
              copy._spawnLanes = copy._spawnLanes.concat([SpawnLane.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._spawnLanes.length === 0) {
                return this;
              }
              const copy = new SpawnWave(this);
              copy._spawnLanes = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._spawnLanes.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new SpawnWave(this);
              copy._spawnLanes = copy._spawnLanes.slice();
              copy._spawnLanes[path[1]] = SpawnLane.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new SpawnWave(this);
              copy._spawnLanes = copy._spawnLanes.slice(0, path[1]).concat(copy._spawnLanes.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._spawnLanes.length) {
            return this;
          }
          const oldValue = this._spawnLanes[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new SpawnWave(this);
          copy._spawnLanes = copy._spawnLanes.slice();
          copy._spawnLanes[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {SpawnWave} other
   * @returns {SpawnWave}
   */
  merge(other) {
    const copy = new SpawnWave(this);
    if (other._hasDisabled) {
      copy._hasDisabled = true;
      copy._disabled = other._disabled;
    }
    if (other._hasTotalGold) {
      copy._hasTotalGold = true;
      copy._totalGold = other._totalGold;
    }
    if (other._hasBonusGold) {
      copy._hasBonusGold = true;
      copy._bonusGold = other._bonusGold;
    }
    if (other._hasStartDelay) {
      copy._hasStartDelay = true;
      copy._startDelay = other._startDelay;
    }
    if (other._hasCallWaveCountdown) {
      copy._hasCallWaveCountdown = true;
      copy._callWaveCountdown = other._callWaveCountdown;
    }
    copy._lanes = {...this._lanes, ...other._lanes};
    copy._spawnLanes = this._spawnLanes.concat(other._spawnLanes);
    return copy;
  }
}
SpawnWave.default = new SpawnWave();
SpawnWave.DeprecatedLanesEntry = SpawnWave_DeprecatedLanesEntry;
class SpawnWave_Builder {
  constructor(value) {
    this._value = new SpawnWave(value);
  }
  build() {
    return new SpawnWave(this._value);
  }
  setDisabled(value) {
    this._value._hasDisabled = true;
    this._value._disabled = value;
    return this;
  }
  deleteDisabled() {
    this._value._hasDisabled = false;
    this._value._disabled = null;
    return this;
  }
  setTotalGold(value) {
    this._value._hasTotalGold = true;
    this._value._totalGold = value;
    return this;
  }
  deleteTotalGold() {
    this._value._hasTotalGold = false;
    this._value._totalGold = null;
    return this;
  }
  setBonusGold(value) {
    this._value._hasBonusGold = true;
    this._value._bonusGold = value;
    return this;
  }
  deleteBonusGold() {
    this._value._hasBonusGold = false;
    this._value._bonusGold = null;
    return this;
  }
  setStartDelay(value) {
    this._value._hasStartDelay = true;
    this._value._startDelay = value;
    return this;
  }
  deleteStartDelay() {
    this._value._hasStartDelay = false;
    this._value._startDelay = null;
    return this;
  }
  setCallWaveCountdown(value) {
    this._value._hasCallWaveCountdown = true;
    this._value._callWaveCountdown = value;
    return this;
  }
  deleteCallWaveCountdown() {
    this._value._hasCallWaveCountdown = false;
    this._value._callWaveCountdown = null;
    return this;
  }
  setDeprecatedLanes(key, value) {
    this._value._lanes = {...this._value._lanes, [key]: value};
    return this;
  }
  addAllDeprecatedLanes(values) {
    this._value._lanes = {...this._value._lanes, ...values};
    return this;
  }
  deleteDeprecatedLanes(key) {
    this._value._lanes = {...this._value._lanes};
    delete this._value._lanes[key];
    return this;
  }
  clearDeprecatedLanes() {
    this._value._lanes = {};
    return this;
  }
  addAllSpawnLanes(values) {
    this._value._spawnLanes = this._value._spawnLanes.concat(values);
    return this;
  }
  addSpawnLanes(value) {
    this._value._spawnLanes = this._value._spawnLanes.concat([value]);
    return this;
  }
  setSpawnLanes(index, value) {
    this._value._spawnLanes = this._value._spawnLanes.concat();
    this._value._spawnLanes[index] = value;
    return this;
  }
  clearSpawnLanes() {
    this._value._spawnLanes = [];
    return this;
  }
}
SpawnWave.Builder = SpawnWave_Builder;
class SpawnWave_WithParent {
  /**
   * @param {SpawnWave} value
   * @param {SpawnWave_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return SpawnWave.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasDisabled() {
    if (this._cachedHasDisabled === undefined) {
      if (this._value.hasDisabled) {
        this._cachedHasDisabled = true;
      } else {
        this._cachedHasDisabled = this._parent ? this._parent.hasDisabled : false;
      }
    }
    return this._cachedHasDisabled;
  }
  get disabled() {
    if (this._cachedDisabled === undefined) {
      if (this._value.hasDisabled) {
        this._cachedDisabled = this._value.disabled;
      } else {
        this._cachedDisabled = this._parent ? this._parent.disabled : this._value.disabled;
      }
    }
    return this._cachedDisabled;
  }
  get hasTotalGold() {
    if (this._cachedHasTotalGold === undefined) {
      if (this._value.hasTotalGold) {
        this._cachedHasTotalGold = true;
      } else {
        this._cachedHasTotalGold = this._parent ? this._parent.hasTotalGold : false;
      }
    }
    return this._cachedHasTotalGold;
  }
  get totalGold() {
    if (this._cachedTotalGold === undefined) {
      if (this._value.hasTotalGold) {
        this._cachedTotalGold = this._value.totalGold;
      } else {
        this._cachedTotalGold = this._parent ? this._parent.totalGold : this._value.totalGold;
      }
    }
    return this._cachedTotalGold;
  }
  get hasBonusGold() {
    if (this._cachedHasBonusGold === undefined) {
      if (this._value.hasBonusGold) {
        this._cachedHasBonusGold = true;
      } else {
        this._cachedHasBonusGold = this._parent ? this._parent.hasBonusGold : false;
      }
    }
    return this._cachedHasBonusGold;
  }
  get bonusGold() {
    if (this._cachedBonusGold === undefined) {
      if (this._value.hasBonusGold) {
        this._cachedBonusGold = this._value.bonusGold;
      } else {
        this._cachedBonusGold = this._parent ? this._parent.bonusGold : this._value.bonusGold;
      }
    }
    return this._cachedBonusGold;
  }
  get hasStartDelay() {
    if (this._cachedHasStartDelay === undefined) {
      if (this._value.hasStartDelay) {
        this._cachedHasStartDelay = true;
      } else {
        this._cachedHasStartDelay = this._parent ? this._parent.hasStartDelay : false;
      }
    }
    return this._cachedHasStartDelay;
  }
  get startDelay() {
    if (this._cachedStartDelay === undefined) {
      if (this._value.hasStartDelay) {
        this._cachedStartDelay = this._value.startDelay;
      } else {
        this._cachedStartDelay = this._parent ? this._parent.startDelay : this._value.startDelay;
      }
    }
    return this._cachedStartDelay;
  }
  get hasCallWaveCountdown() {
    if (this._cachedHasCallWaveCountdown === undefined) {
      if (this._value.hasCallWaveCountdown) {
        this._cachedHasCallWaveCountdown = true;
      } else {
        this._cachedHasCallWaveCountdown = this._parent ? this._parent.hasCallWaveCountdown : false;
      }
    }
    return this._cachedHasCallWaveCountdown;
  }
  get callWaveCountdown() {
    if (this._cachedCallWaveCountdown === undefined) {
      if (this._value.hasCallWaveCountdown) {
        this._cachedCallWaveCountdown = this._value.callWaveCountdown;
      } else {
        this._cachedCallWaveCountdown = this._parent ? this._parent.callWaveCountdown : this._value.callWaveCountdown;
      }
    }
    return this._cachedCallWaveCountdown;
  }
  get selfDeprecatedLanes() {
    if (!this._selfDeprecatedLanes) {
      this._selfDeprecatedLanes = {};
      for (let i in this._value.lanes) {
        this._selfDeprecatedLanes[i] = new SpawnLane.WithParent(this._value.lanes[i], null);
      }
    }
    return this._selfDeprecatedLanes;
  }
  get inherentDeprecatedLanes() {
    if (!this._inherentDeprecatedLanes) {
      this._inherentDeprecatedLanes = this._parent ? this._parent.lanes : {};
    }
    return this._inherentDeprecatedLanes;
  }
  get lanes() {
    if (!this._allDeprecatedLanes) {
      this._allDeprecatedLanes = this._parent ? {...this._parent.lanes, ...this.selfDeprecatedLanes} : this.selfDeprecatedLanes;
    }
    return this._allDeprecatedLanes;
  }
  get selfSpawnLanes() {
    if (!this._selfSpawnLanes) {
      this._selfSpawnLanes = [];
      for (let i of this._value.spawnLanes) {
        this._selfSpawnLanes.push(new SpawnLane.WithParent(i, null));
      }
    }
    return this._selfSpawnLanes;
  }
  get inherentSpawnLanes() {
    if (!this._inherentSpawnLanes) {
      this._inherentSpawnLanes = this._parent ? this._parent.spawnLanes : [];
    }
    return this._inherentSpawnLanes;
  }
  get spawnLanes() {
    if (!this._allSpawnLanes) {
      this._allSpawnLanes = this._parent ? this._parent.spawnLanes.concat(this.selfSpawnLanes) : this.selfSpawnLanes;
    }
    return this._allSpawnLanes;
  }
  update(current, parent) {
    const result = new SpawnWave_WithParent(current, parent);
    if (this._selfDeprecatedLanes) {
      if (this._value.lanes === current.lanes) {
        result._selfDeprecatedLanes = this._selfDeprecatedLanes;
      } else {
        result._selfDeprecatedLanes = {};
        for (let i in current.lanes) {
          const oldValue = this._value.lanes[i];
          if (oldValue) {
            const oldCache = this._selfDeprecatedLanes[i];
            if (oldValue === current.lanes[i]) {
              result._selfDeprecatedLanes[i] = oldCache;
            } else {
              result._selfDeprecatedLanes[i] = oldCache.update(current.lanes[i], null);
            }
          } else {
            result._selfDeprecatedLanes[i] = new SpawnLane.WithParent(current.lanes[i], null);
          }
        }
      }
    }
    if (this._selfSpawnLanes) {
      if (this._value.spawnLanes === current.spawnLanes) {
        result._selfSpawnLanes = this._selfSpawnLanes;
      } else {
        result._selfSpawnLanes = [];
        for (let i = 0; i < current.spawnLanes.length; i++) {
          const oldValue = this._value.spawnLanes[i];
          if (oldValue) {
            const oldCache = this._selfSpawnLanes[i];
            if (oldValue === current.spawnLanes[i]) {
              result._selfSpawnLanes[i] = oldCache;
            } else {
              result._selfSpawnLanes[i] = oldCache.update(current.spawnLanes[i], null);
            }
          } else {
            result._selfSpawnLanes[i] = new SpawnLane.WithParent(current.spawnLanes[i], null);
          }
        }
      }
    }
    return result;
  }
}
SpawnWave_WithParent.default = new SpawnWave_WithParent(SpawnWave.default, null);
SpawnWave.WithParent = SpawnWave_WithParent;
class SpawnWave_Descriptor {
  get disabled() {
    if (!this._disabled) {
      this._disabled = {
        name: "disabled",
        Name: "Disabled",
        number: 1,
        protoType: 8,
        protoName: "disabled",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._disabled;
  }
  get totalGold() {
    if (!this._totalGold) {
      this._totalGold = {
        name: "totalGold",
        Name: "TotalGold",
        number: 2,
        protoType: 5,
        protoName: "total_gold",
        type: JsonToInt32,
        options: {
          min: 0,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._totalGold;
  }
  get bonusGold() {
    if (!this._bonusGold) {
      this._bonusGold = {
        name: "bonusGold",
        Name: "BonusGold",
        number: 3,
        protoType: 5,
        protoName: "bonus_gold",
        type: JsonToInt32,
        options: {
          comments: "Bonus gold will be awarded to player once the previous wave has finished spawning. For the first wave, its bonus gold is awarded right after the game starts.",
          min: 0,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._bonusGold;
  }
  get startDelay() {
    if (!this._startDelay) {
      this._startDelay = {
        name: "startDelay",
        Name: "StartDelay",
        number: 4,
        protoType: 1,
        protoName: "start_delay",
        type: JsonToDouble,
        options: {
          comments: "First degree delay, which is implicit and does not show Call Wave Button. Will go to second degree delay when this value reaches 0.",
          min: 0,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._startDelay;
  }
  get callWaveCountdown() {
    if (!this._callWaveCountdown) {
      this._callWaveCountdown = {
        name: "callWaveCountdown",
        Name: "CallWaveCountdown",
        number: 5,
        protoType: 1,
        protoName: "call_wave_countdown",
        type: JsonToDouble,
        options: {
          comments: "Second degree delay, will show Call Wave Button. Will spawn once this reaches 0.",
          min: 0,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._callWaveCountdown;
  }
  get lanes() {
    if (!this._lanes) {
      this._lanes = {
        name: "lanes",
        Name: "DeprecatedLanes",
        number: 1006,
        protoType: 11,
        protoName: "deprecated_lanes",
        isMap: true,
        keyType: JsonToString,
        valueType: SpawnLane,
        keyProtoType: 9,
        valueProtoType: 11,
        options: {
          hideInInspector: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._lanes;
  }
  get spawnLanes() {
    if (!this._spawnLanes) {
      this._spawnLanes = {
        name: "spawnLanes",
        Name: "SpawnLanes",
        number: 6,
        protoType: 11,
        protoName: "spawn_lanes",
        type: SpawnLane,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._spawnLanes;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.disabled,
        this.totalGold,
        this.bonusGold,
        this.startDelay,
        this.callWaveCountdown,
        this.lanes,
        this.spawnLanes,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForDisabled",
        Name: "DummyOneofForDisabled",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForTotalGold",
        Name: "DummyOneofForTotalGold",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForBonusGold",
        Name: "DummyOneofForBonusGold",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForStartDelay",
        Name: "DummyOneofForStartDelay",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCallWaveCountdown",
        Name: "DummyOneofForCallWaveCountdown",
        fields: [
          this.fields[4],
        ],
      });
    }
    return this._oneofs;
  }
}
SpawnWave.descriptor = new SpawnWave_Descriptor();
class SpawnLane_DeprecatedSpawnGroupsEntry {
  get descriptor() {
    return SpawnLane_DeprecatedSpawnGroupsEntry.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasKey = false;
    this._key = null;
    this._hasValue = false;
    this._value = null;
  }
  isEmpty() {
    if (this._hasKey) return false;
    if (this._hasValue && !this._value.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof SpawnLane_DeprecatedSpawnGroupsEntry) {
      return value;
    }
    return SpawnLane_DeprecatedSpawnGroupsEntry.fromJson(value);
  }
  static fromJson(json) {
    const result = new SpawnLane_DeprecatedSpawnGroupsEntry();
    if (json.key != null) {
      result._hasKey = true;
      result._key = JsonToString.fromJson(json.key);
    }
    if (json.value != null) {
      result._hasValue = true;
      result._value = SubWave.fromJson(json.value);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasKey) {
      result.key = JsonToString.toJson(this._key);
    }
    if (this._hasValue && !this._value.isEmpty()) {
      result.value = SubWave.toJson(this._value);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get key() {
    return this._hasKey ? this._key : JsonToString.default;
  }
  get hasKey() {
    return this._hasKey;
  }
  setKey(path, value) {
    return {type: 'SET', path: path.concat(['key']), value};
  }
  deleteKey(path) {
    return {type: 'DELETE', path: path.concat(['key'])};
  }
  /**
   * @returns {SubWave}
   */
  get value() {
    return this._hasValue ? this._value : SubWave.default;
  }
  get hasValue() {
    return this._hasValue;
  }
  setValue(path, value) {
    return {type: 'SET', path: path.concat(['value']), value: value.toJson()};
  }
  deleteValue(path) {
    return {type: 'DELETE', path: path.concat(['value'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "key": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SpawnLane_DeprecatedSpawnGroupsEntry(this);
              copy._hasKey = true;
              copy._key = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKey) {
                return this;
              }
              const copy = new SpawnLane_DeprecatedSpawnGroupsEntry(this);
              copy._hasKey = false;
              copy._key = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "value": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SpawnLane_DeprecatedSpawnGroupsEntry(this);
              copy._hasValue = true;
              copy._value = SubWave.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasValue) {
                return this;
              }
              const copy = new SpawnLane_DeprecatedSpawnGroupsEntry(this);
              copy._hasValue = false;
              copy._value = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasValue) {
            const copy = new SpawnLane_DeprecatedSpawnGroupsEntry(this);
            copy._hasValue = true;
            copy._value = SubWave.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._value.apply(type, path.slice(1), value);
          if (newValue === this._value) {
            return this;
          }
          const copy = new SpawnLane_DeprecatedSpawnGroupsEntry(this);
          copy._value = copy._value.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {SpawnLane_DeprecatedSpawnGroupsEntry} other
   * @returns {SpawnLane_DeprecatedSpawnGroupsEntry}
   */
  merge(other) {
    const copy = new SpawnLane_DeprecatedSpawnGroupsEntry(this);
    if (other._hasKey) {
      copy._hasKey = true;
      copy._key = other._key;
    }
    if (other._hasValue) {
      if (copy._hasValue) {
        copy._value = copy.value.merge(other.value);
      } else {
        copy._value = other._value;
      }
      copy._hasValue = true;
    }
    return copy;
  }
}
SpawnLane_DeprecatedSpawnGroupsEntry.default = new SpawnLane_DeprecatedSpawnGroupsEntry();
class SpawnLane_DeprecatedSpawnGroupsEntry_Builder {
  constructor(value) {
    this._value = new SpawnLane_DeprecatedSpawnGroupsEntry(value);
  }
  build() {
    return new SpawnLane_DeprecatedSpawnGroupsEntry(this._value);
  }
  setKey(value) {
    this._value._hasKey = true;
    this._value._key = value;
    return this;
  }
  deleteKey() {
    this._value._hasKey = false;
    this._value._key = null;
    return this;
  }
  setValue(value) {
    this._value._hasValue = true;
    this._value._value = value;
    return this;
  }
  deleteValue() {
    this._value._hasValue = false;
    this._value._value = null;
    return this;
  }
}
SpawnLane_DeprecatedSpawnGroupsEntry.Builder = SpawnLane_DeprecatedSpawnGroupsEntry_Builder;
class SpawnLane_DeprecatedSpawnGroupsEntry_WithParent {
  /**
   * @param {SpawnLane_DeprecatedSpawnGroupsEntry} value
   * @param {SpawnLane_DeprecatedSpawnGroupsEntry_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return SpawnLane_DeprecatedSpawnGroupsEntry.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasKey() {
    if (this._cachedHasKey === undefined) {
      if (this._value.hasKey) {
        this._cachedHasKey = true;
      } else {
        this._cachedHasKey = this._parent ? this._parent.hasKey : false;
      }
    }
    return this._cachedHasKey;
  }
  get key() {
    if (this._cachedKey === undefined) {
      if (this._value.hasKey) {
        this._cachedKey = this._value.key;
      } else {
        this._cachedKey = this._parent ? this._parent.key : this._value.key;
      }
    }
    return this._cachedKey;
  }
  get hasValue() {
    if (this._cachedHasValue === undefined) {
      if (this._value.hasValue) {
        this._cachedHasValue = true;
      } else {
        this._cachedHasValue = this._parent ? this._parent.hasValue : false;
      }
    }
    return this._cachedHasValue;
  }
  get value() {
    if (!this._cachedValue) {
      if (this._value.hasValue) {
        this._cachedValue = new SubWave.WithParent(this._value.value, this._parent && this._parent.hasValue ? this._parent.value : null);
      } else {
        this._cachedValue = this._parent ? new SubWave.WithParent(SubWave.default, this._parent.value) : SubWave.WithParent.default;
      }
    }
    return this._cachedValue;
  }
  update(current, parent) {
    const result = new SpawnLane_DeprecatedSpawnGroupsEntry_WithParent(current, parent);
    if (this._cachedValue && this._value.hasValue && current.hasValue) {
      if (this._value.value === current.value && this._parent === parent) {
        result._cachedValue = this._cachedValue;
      } else {
        result._cachedValue = this._cachedValue.update(current.value, parent && parent.hasValue ? parent.value : null);
      }
    }
    return result;
  }
}
SpawnLane_DeprecatedSpawnGroupsEntry_WithParent.default = new SpawnLane_DeprecatedSpawnGroupsEntry_WithParent(SpawnLane_DeprecatedSpawnGroupsEntry.default, null);
SpawnLane_DeprecatedSpawnGroupsEntry.WithParent = SpawnLane_DeprecatedSpawnGroupsEntry_WithParent;
class SpawnLane_DeprecatedSpawnGroupsEntry_Descriptor {
  get key() {
    if (!this._key) {
      this._key = {
        name: "key",
        Name: "Key",
        number: 1,
        protoType: 9,
        protoName: "key",
        type: JsonToString,
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._key;
  }
  get value() {
    if (!this._value) {
      this._value = {
        name: "value",
        Name: "Value",
        number: 2,
        protoType: 11,
        protoName: "value",
        type: SubWave,
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._value;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.key,
        this.value,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
SpawnLane_DeprecatedSpawnGroupsEntry.descriptor = new SpawnLane_DeprecatedSpawnGroupsEntry_Descriptor();
class SpawnLane_Affinity {
  static fromJson(json) {
    if (typeof json === "string") {
      switch (json) {
        case "NONE": return 0;
        case "PHYSICAL": return 1;
        case "FIRE": return 2;
        case "WATER": return 3;
        case "NATURE": return 4;
        case "LIGHT": return 5;
        case "DARK": return 6;
        default: return 0;
      }
    }
    return json;
  }
  static toJson(value) {
    return value;
  }
  static fromAny(value) {
    return SpawnLane_Affinity.fromJson(value);
  }
  static fromReact(e) {
    return SpawnLane_Affinity.fromJson(e);
  }
}
SpawnLane_Affinity.NONE = 0;
SpawnLane_Affinity.PHYSICAL = 1;
SpawnLane_Affinity.FIRE = 2;
SpawnLane_Affinity.WATER = 3;
SpawnLane_Affinity.NATURE = 4;
SpawnLane_Affinity.LIGHT = 5;
SpawnLane_Affinity.DARK = 6;
SpawnLane_Affinity.default = 0;
SpawnLane_Affinity.values = {
  NONE: 0,
  PHYSICAL: 1,
  FIRE: 2,
  WATER: 3,
  NATURE: 4,
  LIGHT: 5,
  DARK: 6,
};
SpawnLane_Affinity.names = {
  0: "NONE",
  1: "PHYSICAL",
  2: "FIRE",
  3: "WATER",
  4: "NATURE",
  5: "LIGHT",
  6: "DARK",
};
export class SpawnLane {
  get descriptor() {
    return SpawnLane.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasName = false;
    this._name = null;
    this._hasRouteName = false;
    this._routeName = null;
    this._spawnGroups = {};
    this._subWaves = [];
    this._hasHideWaveIndicator = false;
    this._hideWaveIndicator = null;
    this._hasAffinity = false;
    this._affinity = null;
  }
  isEmpty() {
    if (this._hasName) return false;
    if (this._hasRouteName) return false;
    if (Object.keys(this._spawnGroups).length > 0) return false;
    if (this._subWaves.length > 0) return false;
    if (this._hasHideWaveIndicator) return false;
    if (this._hasAffinity) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof SpawnLane) {
      return value;
    }
    return SpawnLane.fromJson(value);
  }
  static fromJson(json) {
    const result = new SpawnLane();
    if (json.name != null) {
      result._hasName = true;
      result._name = JsonToString.fromJson(json.name);
    }
    if (json.routeName != null) {
      result._hasRouteName = true;
      result._routeName = JsonToString.fromJson(json.routeName);
    }
    result._spawnGroups = JsonToMap(json.spawnGroups, JsonToString, SubWave);
    result._subWaves = JsonToList(json.subWaves, SubWave);
    if (json.hideWaveIndicator != null) {
      result._hasHideWaveIndicator = true;
      result._hideWaveIndicator = JsonToBoolean.fromJson(json.hideWaveIndicator);
    }
    if (json.affinity != null) {
      result._hasAffinity = true;
      result._affinity = SpawnLane_Affinity.fromJson(json.affinity);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasName) {
      result.name = JsonToString.toJson(this._name);
    }
    if (this._hasRouteName) {
      result.routeName = JsonToString.toJson(this._routeName);
    }
    if (Object.keys(this._spawnGroups).length > 0) {
      result.spawnGroups = MapToJson(this._spawnGroups, JsonToString, SubWave);
    }
    if (this._subWaves.length > 0) {
      result.subWaves = ArrayToJson(this._subWaves, SubWave);
    }
    if (this._hasHideWaveIndicator) {
      result.hideWaveIndicator = JsonToBoolean.toJson(this._hideWaveIndicator);
    }
    if (this._hasAffinity) {
      result.affinity = SpawnLane_Affinity.toJson(this._affinity);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get name() {
    return this._hasName ? this._name : JsonToString.default;
  }
  get hasName() {
    return this._hasName;
  }
  setName(path, value) {
    return {type: 'SET', path: path.concat(['name']), value};
  }
  deleteName(path) {
    return {type: 'DELETE', path: path.concat(['name'])};
  }
  /**
   * @returns {string}
   */
  get routeName() {
    return this._hasRouteName ? this._routeName : JsonToString.default;
  }
  get hasRouteName() {
    return this._hasRouteName;
  }
  setRouteName(path, value) {
    return {type: 'SET', path: path.concat(['routeName']), value};
  }
  deleteRouteName(path) {
    return {type: 'DELETE', path: path.concat(['routeName'])};
  }
  /**
   * @returns {Object<string, SubWave>}
   */
  get spawnGroups() {
    return this._spawnGroups;
  }
  setDeprecatedSpawnGroups(path, value) {
    return {type: 'SET', path: path.concat(['spawnGroups']), value: MapToJson(value, JsonToString, SubWave)};
  }
  setDeprecatedSpawnGroupsByKey(path, key, value) {
    return {type: 'SET', path: path.concat(['spawnGroups', key]), value: value.toJson()};
  }
  deleteDeprecatedSpawnGroups(path) {
    return {type: 'DELETE', path: path.concat(['spawnGroups'])};
  }
  deleteDeprecatedSpawnGroupsByKey(path, key) {
    return {type: 'DELETE', path: path.concat(['spawnGroups', key])};
  }
  /**
   * @returns {SubWave[]}
   */
  get subWaves() {
    return this._subWaves;
  }
  addSubWaves(path, value) {
    return {type: 'ADD', path: path.concat(['subWaves']), value: value.toJson()};
  }
  setSubWaves(path, value) {
    return {type: 'SET', path: path.concat(['subWaves']), value: ArrayToJson(value, SubWave)};
  }
  setSubWavesByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['subWaves', key]), value: value.toJson()};
  }
  deleteSubWaves(path) {
    return {type: 'DELETE', path: path.concat(['subWaves'])};
  }
  deleteSubWavesByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['subWaves', key])};
  }
  /**
   * @returns {boolean}
   */
  get hideWaveIndicator() {
    return this._hasHideWaveIndicator ? this._hideWaveIndicator : JsonToBoolean.default;
  }
  get hasHideWaveIndicator() {
    return this._hasHideWaveIndicator;
  }
  setHideWaveIndicator(path, value) {
    return {type: 'SET', path: path.concat(['hideWaveIndicator']), value};
  }
  deleteHideWaveIndicator(path) {
    return {type: 'DELETE', path: path.concat(['hideWaveIndicator'])};
  }
  /**
   * @returns {number}
   */
  get affinity() {
    return this._hasAffinity ? this._affinity : SpawnLane_Affinity.default;
  }
  get hasAffinity() {
    return this._hasAffinity;
  }
  setAffinity(path, value) {
    return {type: 'SET', path: path.concat(['affinity']), value};
  }
  deleteAffinity(path) {
    return {type: 'DELETE', path: path.concat(['affinity'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "name": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SpawnLane(this);
              copy._hasName = true;
              copy._name = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasName) {
                return this;
              }
              const copy = new SpawnLane(this);
              copy._hasName = false;
              copy._name = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "routeName": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SpawnLane(this);
              copy._hasRouteName = true;
              copy._routeName = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasRouteName) {
                return this;
              }
              const copy = new SpawnLane(this);
              copy._hasRouteName = false;
              copy._routeName = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "spawnGroups": {
        if (path.length === 1) {
          switch (type) {
            case 'DELETE': {
              if (Object.keys(this._spawnGroups).length === 0) {
                return this;
              }
              const copy = new SpawnLane(this);
              copy._spawnGroups = {};
              return copy;
            }
            case 'SET': {
              const copy = new SpawnLane(this);
              copy._spawnGroups = {};
              for (let key in value) {
                copy._spawnGroups[key] = SubWave.fromAny(value[key]);
              }
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          switch (type) {
            case 'SET': {
              const copy = new SpawnLane(this);
              copy._spawnGroups = {...copy._spawnGroups};
              copy._spawnGroups[path[1]] = SubWave.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._spawnGroups[path[1]]) {
                return this;
              }
              const copy = new SpawnLane(this);
              copy._spawnGroups = {...copy._spawnGroups};
              delete copy._spawnGroups[path[1]];
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (this._spawnGroups[key] === undefined) {
            const copy = new SpawnLane(this);
            copy._spawnGroups = {...copy._spawnGroups};
            copy._spawnGroups[key] = SubWave.default.apply(type, path.slice(2), value);
            return copy;
          }
          const oldValue = this._spawnGroups[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new SpawnLane(this);
          copy._spawnGroups = {...copy._spawnGroups};
          copy._spawnGroups[key] = newValue;
          return copy;
        }
      }
      case "subWaves": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SpawnLane(this);
              copy._subWaves = [];        for (let i of value) {
                copy._subWaves.push(SubWave.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new SpawnLane(this);
              copy._subWaves = copy._subWaves.concat([SubWave.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._subWaves.length === 0) {
                return this;
              }
              const copy = new SpawnLane(this);
              copy._subWaves = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._subWaves.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new SpawnLane(this);
              copy._subWaves = copy._subWaves.slice();
              copy._subWaves[path[1]] = SubWave.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new SpawnLane(this);
              copy._subWaves = copy._subWaves.slice(0, path[1]).concat(copy._subWaves.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._subWaves.length) {
            return this;
          }
          const oldValue = this._subWaves[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new SpawnLane(this);
          copy._subWaves = copy._subWaves.slice();
          copy._subWaves[key] = newValue;
          return copy;
        }
      }
      case "hideWaveIndicator": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SpawnLane(this);
              copy._hasHideWaveIndicator = true;
              copy._hideWaveIndicator = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasHideWaveIndicator) {
                return this;
              }
              const copy = new SpawnLane(this);
              copy._hasHideWaveIndicator = false;
              copy._hideWaveIndicator = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "affinity": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SpawnLane(this);
              copy._hasAffinity = true;
              copy._affinity = SpawnLane_Affinity.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAffinity) {
                return this;
              }
              const copy = new SpawnLane(this);
              copy._hasAffinity = false;
              copy._affinity = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {SpawnLane} other
   * @returns {SpawnLane}
   */
  merge(other) {
    const copy = new SpawnLane(this);
    if (other._hasName) {
      copy._hasName = true;
      copy._name = other._name;
    }
    if (other._hasRouteName) {
      copy._hasRouteName = true;
      copy._routeName = other._routeName;
    }
    copy._spawnGroups = {...this._spawnGroups, ...other._spawnGroups};
    copy._subWaves = this._subWaves.concat(other._subWaves);
    if (other._hasHideWaveIndicator) {
      copy._hasHideWaveIndicator = true;
      copy._hideWaveIndicator = other._hideWaveIndicator;
    }
    if (other._hasAffinity) {
      copy._hasAffinity = true;
      copy._affinity = other._affinity;
    }
    return copy;
  }
}
SpawnLane.default = new SpawnLane();
SpawnLane.DeprecatedSpawnGroupsEntry = SpawnLane_DeprecatedSpawnGroupsEntry;
SpawnLane.Affinity = SpawnLane_Affinity;
class SpawnLane_Builder {
  constructor(value) {
    this._value = new SpawnLane(value);
  }
  build() {
    return new SpawnLane(this._value);
  }
  setName(value) {
    this._value._hasName = true;
    this._value._name = value;
    return this;
  }
  deleteName() {
    this._value._hasName = false;
    this._value._name = null;
    return this;
  }
  setRouteName(value) {
    this._value._hasRouteName = true;
    this._value._routeName = value;
    return this;
  }
  deleteRouteName() {
    this._value._hasRouteName = false;
    this._value._routeName = null;
    return this;
  }
  setDeprecatedSpawnGroups(key, value) {
    this._value._spawnGroups = {...this._value._spawnGroups, [key]: value};
    return this;
  }
  addAllDeprecatedSpawnGroups(values) {
    this._value._spawnGroups = {...this._value._spawnGroups, ...values};
    return this;
  }
  deleteDeprecatedSpawnGroups(key) {
    this._value._spawnGroups = {...this._value._spawnGroups};
    delete this._value._spawnGroups[key];
    return this;
  }
  clearDeprecatedSpawnGroups() {
    this._value._spawnGroups = {};
    return this;
  }
  addAllSubWaves(values) {
    this._value._subWaves = this._value._subWaves.concat(values);
    return this;
  }
  addSubWaves(value) {
    this._value._subWaves = this._value._subWaves.concat([value]);
    return this;
  }
  setSubWaves(index, value) {
    this._value._subWaves = this._value._subWaves.concat();
    this._value._subWaves[index] = value;
    return this;
  }
  clearSubWaves() {
    this._value._subWaves = [];
    return this;
  }
  setHideWaveIndicator(value) {
    this._value._hasHideWaveIndicator = true;
    this._value._hideWaveIndicator = value;
    return this;
  }
  deleteHideWaveIndicator() {
    this._value._hasHideWaveIndicator = false;
    this._value._hideWaveIndicator = null;
    return this;
  }
  setAffinity(value) {
    this._value._hasAffinity = true;
    this._value._affinity = value;
    return this;
  }
  deleteAffinity() {
    this._value._hasAffinity = false;
    this._value._affinity = null;
    return this;
  }
}
SpawnLane.Builder = SpawnLane_Builder;
class SpawnLane_WithParent {
  /**
   * @param {SpawnLane} value
   * @param {SpawnLane_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return SpawnLane.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasName() {
    if (this._cachedHasName === undefined) {
      if (this._value.hasName) {
        this._cachedHasName = true;
      } else {
        this._cachedHasName = this._parent ? this._parent.hasName : false;
      }
    }
    return this._cachedHasName;
  }
  get name() {
    if (this._cachedName === undefined) {
      if (this._value.hasName) {
        this._cachedName = this._value.name;
      } else {
        this._cachedName = this._parent ? this._parent.name : this._value.name;
      }
    }
    return this._cachedName;
  }
  get hasRouteName() {
    if (this._cachedHasRouteName === undefined) {
      if (this._value.hasRouteName) {
        this._cachedHasRouteName = true;
      } else {
        this._cachedHasRouteName = this._parent ? this._parent.hasRouteName : false;
      }
    }
    return this._cachedHasRouteName;
  }
  get routeName() {
    if (this._cachedRouteName === undefined) {
      if (this._value.hasRouteName) {
        this._cachedRouteName = this._value.routeName;
      } else {
        this._cachedRouteName = this._parent ? this._parent.routeName : this._value.routeName;
      }
    }
    return this._cachedRouteName;
  }
  get selfDeprecatedSpawnGroups() {
    if (!this._selfDeprecatedSpawnGroups) {
      this._selfDeprecatedSpawnGroups = {};
      for (let i in this._value.spawnGroups) {
        this._selfDeprecatedSpawnGroups[i] = new SubWave.WithParent(this._value.spawnGroups[i], null);
      }
    }
    return this._selfDeprecatedSpawnGroups;
  }
  get inherentDeprecatedSpawnGroups() {
    if (!this._inherentDeprecatedSpawnGroups) {
      this._inherentDeprecatedSpawnGroups = this._parent ? this._parent.spawnGroups : {};
    }
    return this._inherentDeprecatedSpawnGroups;
  }
  get spawnGroups() {
    if (!this._allDeprecatedSpawnGroups) {
      this._allDeprecatedSpawnGroups = this._parent ? {...this._parent.spawnGroups, ...this.selfDeprecatedSpawnGroups} : this.selfDeprecatedSpawnGroups;
    }
    return this._allDeprecatedSpawnGroups;
  }
  get selfSubWaves() {
    if (!this._selfSubWaves) {
      this._selfSubWaves = [];
      for (let i of this._value.subWaves) {
        this._selfSubWaves.push(new SubWave.WithParent(i, null));
      }
    }
    return this._selfSubWaves;
  }
  get inherentSubWaves() {
    if (!this._inherentSubWaves) {
      this._inherentSubWaves = this._parent ? this._parent.subWaves : [];
    }
    return this._inherentSubWaves;
  }
  get subWaves() {
    if (!this._allSubWaves) {
      this._allSubWaves = this._parent ? this._parent.subWaves.concat(this.selfSubWaves) : this.selfSubWaves;
    }
    return this._allSubWaves;
  }
  get hasHideWaveIndicator() {
    if (this._cachedHasHideWaveIndicator === undefined) {
      if (this._value.hasHideWaveIndicator) {
        this._cachedHasHideWaveIndicator = true;
      } else {
        this._cachedHasHideWaveIndicator = this._parent ? this._parent.hasHideWaveIndicator : false;
      }
    }
    return this._cachedHasHideWaveIndicator;
  }
  get hideWaveIndicator() {
    if (this._cachedHideWaveIndicator === undefined) {
      if (this._value.hasHideWaveIndicator) {
        this._cachedHideWaveIndicator = this._value.hideWaveIndicator;
      } else {
        this._cachedHideWaveIndicator = this._parent ? this._parent.hideWaveIndicator : this._value.hideWaveIndicator;
      }
    }
    return this._cachedHideWaveIndicator;
  }
  get hasAffinity() {
    if (this._cachedHasAffinity === undefined) {
      if (this._value.hasAffinity) {
        this._cachedHasAffinity = true;
      } else {
        this._cachedHasAffinity = this._parent ? this._parent.hasAffinity : false;
      }
    }
    return this._cachedHasAffinity;
  }
  get affinity() {
    if (this._cachedAffinity === undefined) {
      if (this._value.hasAffinity) {
        this._cachedAffinity = this._value.affinity;
      } else {
        this._cachedAffinity = this._parent ? this._parent.affinity : this._value.affinity;
      }
    }
    return this._cachedAffinity;
  }
  update(current, parent) {
    const result = new SpawnLane_WithParent(current, parent);
    if (this._selfDeprecatedSpawnGroups) {
      if (this._value.spawnGroups === current.spawnGroups) {
        result._selfDeprecatedSpawnGroups = this._selfDeprecatedSpawnGroups;
      } else {
        result._selfDeprecatedSpawnGroups = {};
        for (let i in current.spawnGroups) {
          const oldValue = this._value.spawnGroups[i];
          if (oldValue) {
            const oldCache = this._selfDeprecatedSpawnGroups[i];
            if (oldValue === current.spawnGroups[i]) {
              result._selfDeprecatedSpawnGroups[i] = oldCache;
            } else {
              result._selfDeprecatedSpawnGroups[i] = oldCache.update(current.spawnGroups[i], null);
            }
          } else {
            result._selfDeprecatedSpawnGroups[i] = new SubWave.WithParent(current.spawnGroups[i], null);
          }
        }
      }
    }
    if (this._selfSubWaves) {
      if (this._value.subWaves === current.subWaves) {
        result._selfSubWaves = this._selfSubWaves;
      } else {
        result._selfSubWaves = [];
        for (let i = 0; i < current.subWaves.length; i++) {
          const oldValue = this._value.subWaves[i];
          if (oldValue) {
            const oldCache = this._selfSubWaves[i];
            if (oldValue === current.subWaves[i]) {
              result._selfSubWaves[i] = oldCache;
            } else {
              result._selfSubWaves[i] = oldCache.update(current.subWaves[i], null);
            }
          } else {
            result._selfSubWaves[i] = new SubWave.WithParent(current.subWaves[i], null);
          }
        }
      }
    }
    return result;
  }
}
SpawnLane_WithParent.default = new SpawnLane_WithParent(SpawnLane.default, null);
SpawnLane.WithParent = SpawnLane_WithParent;
class SpawnLane_Descriptor {
  get name() {
    if (!this._name) {
      this._name = {
        name: "name",
        Name: "Name",
        number: 1,
        protoType: 9,
        protoName: "name",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._name;
  }
  get routeName() {
    if (!this._routeName) {
      this._routeName = {
        name: "routeName",
        Name: "RouteName",
        number: 2,
        protoType: 9,
        protoName: "route_name",
        type: JsonToString,
        options: {
          valueDropdown: "SupportedWaypointNameList",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._routeName;
  }
  get spawnGroups() {
    if (!this._spawnGroups) {
      this._spawnGroups = {
        name: "spawnGroups",
        Name: "DeprecatedSpawnGroups",
        number: 1003,
        protoType: 11,
        protoName: "deprecated_spawn_groups",
        isMap: true,
        keyType: JsonToString,
        valueType: SubWave,
        keyProtoType: 9,
        valueProtoType: 11,
        options: {
          hideInInspector: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._spawnGroups;
  }
  get subWaves() {
    if (!this._subWaves) {
      this._subWaves = {
        name: "subWaves",
        Name: "SubWaves",
        number: 3,
        protoType: 11,
        protoName: "sub_waves",
        type: SubWave,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._subWaves;
  }
  get hideWaveIndicator() {
    if (!this._hideWaveIndicator) {
      this._hideWaveIndicator = {
        name: "hideWaveIndicator",
        Name: "HideWaveIndicator",
        number: 4,
        protoType: 8,
        protoName: "hide_wave_indicator",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._hideWaveIndicator;
  }
  get affinity() {
    if (!this._affinity) {
      this._affinity = {
        name: "affinity",
        Name: "Affinity",
        number: 5,
        protoType: 14,
        protoName: "affinity",
        type: SpawnLane_Affinity,
        options: {
          comments: "Affinity of creeps in this lane.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._affinity;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.name,
        this.routeName,
        this.spawnGroups,
        this.subWaves,
        this.hideWaveIndicator,
        this.affinity,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForName",
        Name: "DummyOneofForName",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForRouteName",
        Name: "DummyOneofForRouteName",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForHideWaveIndicator",
        Name: "DummyOneofForHideWaveIndicator",
        fields: [
          this.fields[4],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForAffinity",
        Name: "DummyOneofForAffinity",
        fields: [
          this.fields[5],
        ],
      });
    }
    return this._oneofs;
  }
}
SpawnLane.descriptor = new SpawnLane_Descriptor();
export class SubWave {
  get descriptor() {
    return SubWave.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasName = false;
    this._name = null;
    this._hasNote = false;
    this._note = null;
    this._hasGroupPattern = false;
    this._groupPattern = null;
    this._hasUnitType = false;
    this._unitType = null;
    this._hasPatternName = false;
    this._patternName = null;
    this._hasCount = false;
    this._count = null;
    this._hasInitialDelay = false;
    this._initialDelay = null;
    this._yieldGroup = [];
  }
  isEmpty() {
    if (this._hasName) return false;
    if (this._hasNote) return false;
    if (this._hasGroupPattern) return false;
    if (this._hasUnitType) return false;
    if (this._hasPatternName) return false;
    if (this._hasCount) return false;
    if (this._hasInitialDelay) return false;
    if (this._yieldGroup.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof SubWave) {
      return value;
    }
    return SubWave.fromJson(value);
  }
  static fromJson(json) {
    const result = new SubWave();
    if (json.name != null) {
      result._hasName = true;
      result._name = JsonToString.fromJson(json.name);
    }
    if (json.note != null) {
      result._hasNote = true;
      result._note = JsonToString.fromJson(json.note);
    }
    if (json.groupPattern != null) {
      result._hasGroupPattern = true;
      result._groupPattern = JsonToString.fromJson(json.groupPattern);
    }
    if (json.unitType != null) {
      result._hasUnitType = true;
      result._unitType = JsonToString.fromJson(json.unitType);
    }
    if (json.patternName != null) {
      result._hasPatternName = true;
      result._patternName = JsonToString.fromJson(json.patternName);
    }
    if (json.count != null) {
      result._hasCount = true;
      result._count = JsonToInt32.fromJson(json.count);
    }
    if (json.initialDelay != null) {
      result._hasInitialDelay = true;
      result._initialDelay = JsonToDouble.fromJson(json.initialDelay);
    }
    result._yieldGroup = JsonToList(json.yieldGroup, JsonToString);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasName) {
      result.name = JsonToString.toJson(this._name);
    }
    if (this._hasNote) {
      result.note = JsonToString.toJson(this._note);
    }
    if (this._hasGroupPattern) {
      result.groupPattern = JsonToString.toJson(this._groupPattern);
    }
    if (this._hasUnitType) {
      result.unitType = JsonToString.toJson(this._unitType);
    }
    if (this._hasPatternName) {
      result.patternName = JsonToString.toJson(this._patternName);
    }
    if (this._hasCount) {
      result.count = JsonToInt32.toJson(this._count);
    }
    if (this._hasInitialDelay) {
      result.initialDelay = JsonToDouble.toJson(this._initialDelay);
    }
    if (this._yieldGroup.length > 0) {
      result.yieldGroup = ArrayToJson(this._yieldGroup, JsonToString);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get name() {
    return this._hasName ? this._name : JsonToString.default;
  }
  get hasName() {
    return this._hasName;
  }
  setName(path, value) {
    return {type: 'SET', path: path.concat(['name']), value};
  }
  deleteName(path) {
    return {type: 'DELETE', path: path.concat(['name'])};
  }
  /**
   * @returns {string}
   */
  get note() {
    return this._hasNote ? this._note : JsonToString.default;
  }
  get hasNote() {
    return this._hasNote;
  }
  setNote(path, value) {
    return {type: 'SET', path: path.concat(['note']), value};
  }
  deleteNote(path) {
    return {type: 'DELETE', path: path.concat(['note'])};
  }
  /**
   * @returns {string}
   */
  get groupPattern() {
    return this._hasGroupPattern ? this._groupPattern : JsonToString.default;
  }
  get hasGroupPattern() {
    return this._hasGroupPattern;
  }
  setGroupPattern(path, value) {
    return {type: 'SET', path: path.concat(['groupPattern']), value};
  }
  deleteGroupPattern(path) {
    return {type: 'DELETE', path: path.concat(['groupPattern'])};
  }
  /**
   * @returns {string}
   */
  get unitType() {
    return this._hasUnitType ? this._unitType : JsonToString.default;
  }
  get hasUnitType() {
    return this._hasUnitType;
  }
  setUnitType(path, value) {
    return {type: 'SET', path: path.concat(['unitType']), value};
  }
  deleteUnitType(path) {
    return {type: 'DELETE', path: path.concat(['unitType'])};
  }
  /**
   * @returns {string}
   */
  get patternName() {
    return this._hasPatternName ? this._patternName : JsonToString.default;
  }
  get hasPatternName() {
    return this._hasPatternName;
  }
  setPatternName(path, value) {
    return {type: 'SET', path: path.concat(['patternName']), value};
  }
  deletePatternName(path) {
    return {type: 'DELETE', path: path.concat(['patternName'])};
  }
  /**
   * @returns {number}
   */
  get count() {
    return this._hasCount ? this._count : JsonToInt32.default;
  }
  get hasCount() {
    return this._hasCount;
  }
  setCount(path, value) {
    return {type: 'SET', path: path.concat(['count']), value};
  }
  deleteCount(path) {
    return {type: 'DELETE', path: path.concat(['count'])};
  }
  /**
   * @returns {number}
   */
  get initialDelay() {
    return this._hasInitialDelay ? this._initialDelay : JsonToDouble.default;
  }
  get hasInitialDelay() {
    return this._hasInitialDelay;
  }
  setInitialDelay(path, value) {
    return {type: 'SET', path: path.concat(['initialDelay']), value};
  }
  deleteInitialDelay(path) {
    return {type: 'DELETE', path: path.concat(['initialDelay'])};
  }
  /**
   * @returns {string[]}
   */
  get yieldGroup() {
    return this._yieldGroup;
  }
  addYieldGroup(path, value) {
    return {type: 'ADD', path: path.concat(['yieldGroup']), value};
  }
  setYieldGroup(path, value) {
    return {type: 'SET', path: path.concat(['yieldGroup']), value: ArrayToJson(value, JsonToString)};
  }
  setYieldGroupByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['yieldGroup', key]), value};
  }
  deleteYieldGroup(path) {
    return {type: 'DELETE', path: path.concat(['yieldGroup'])};
  }
  deleteYieldGroupByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['yieldGroup', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "name": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SubWave(this);
              copy._hasName = true;
              copy._name = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasName) {
                return this;
              }
              const copy = new SubWave(this);
              copy._hasName = false;
              copy._name = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "note": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SubWave(this);
              copy._hasNote = true;
              copy._note = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasNote) {
                return this;
              }
              const copy = new SubWave(this);
              copy._hasNote = false;
              copy._note = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "groupPattern": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SubWave(this);
              copy._hasGroupPattern = true;
              copy._groupPattern = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasGroupPattern) {
                return this;
              }
              const copy = new SubWave(this);
              copy._hasGroupPattern = false;
              copy._groupPattern = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "unitType": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SubWave(this);
              copy._hasUnitType = true;
              copy._unitType = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasUnitType) {
                return this;
              }
              const copy = new SubWave(this);
              copy._hasUnitType = false;
              copy._unitType = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "patternName": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SubWave(this);
              copy._hasPatternName = true;
              copy._patternName = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPatternName) {
                return this;
              }
              const copy = new SubWave(this);
              copy._hasPatternName = false;
              copy._patternName = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "count": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SubWave(this);
              copy._hasCount = true;
              copy._count = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCount) {
                return this;
              }
              const copy = new SubWave(this);
              copy._hasCount = false;
              copy._count = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "initialDelay": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SubWave(this);
              copy._hasInitialDelay = true;
              copy._initialDelay = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasInitialDelay) {
                return this;
              }
              const copy = new SubWave(this);
              copy._hasInitialDelay = false;
              copy._initialDelay = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "yieldGroup": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SubWave(this);
              copy._yieldGroup = [];        for (let i of value) {
                copy._yieldGroup.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new SubWave(this);
              copy._yieldGroup = copy._yieldGroup.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._yieldGroup.length === 0) {
                return this;
              }
              const copy = new SubWave(this);
              copy._yieldGroup = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._yieldGroup.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new SubWave(this);
              copy._yieldGroup = copy._yieldGroup.slice();
              copy._yieldGroup[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new SubWave(this);
              copy._yieldGroup = copy._yieldGroup.slice(0, path[1]).concat(copy._yieldGroup.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._yieldGroup.length) {
            return this;
          }
          const oldValue = this._yieldGroup[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new SubWave(this);
          copy._yieldGroup = copy._yieldGroup.slice();
          copy._yieldGroup[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {SubWave} other
   * @returns {SubWave}
   */
  merge(other) {
    const copy = new SubWave(this);
    if (other._hasName) {
      copy._hasName = true;
      copy._name = other._name;
    }
    if (other._hasNote) {
      copy._hasNote = true;
      copy._note = other._note;
    }
    if (other._hasGroupPattern) {
      copy._hasGroupPattern = true;
      copy._groupPattern = other._groupPattern;
    }
    if (other._hasUnitType) {
      copy._hasUnitType = true;
      copy._unitType = other._unitType;
    }
    if (other._hasPatternName) {
      copy._hasPatternName = true;
      copy._patternName = other._patternName;
    }
    if (other._hasCount) {
      copy._hasCount = true;
      copy._count = other._count;
    }
    if (other._hasInitialDelay) {
      copy._hasInitialDelay = true;
      copy._initialDelay = other._initialDelay;
    }
    copy._yieldGroup = this._yieldGroup.concat(other._yieldGroup);
    return copy;
  }
}
SubWave.default = new SubWave();
class SubWave_Builder {
  constructor(value) {
    this._value = new SubWave(value);
  }
  build() {
    return new SubWave(this._value);
  }
  setName(value) {
    this._value._hasName = true;
    this._value._name = value;
    return this;
  }
  deleteName() {
    this._value._hasName = false;
    this._value._name = null;
    return this;
  }
  setNote(value) {
    this._value._hasNote = true;
    this._value._note = value;
    return this;
  }
  deleteNote() {
    this._value._hasNote = false;
    this._value._note = null;
    return this;
  }
  setGroupPattern(value) {
    this._value._hasGroupPattern = true;
    this._value._groupPattern = value;
    return this;
  }
  deleteGroupPattern() {
    this._value._hasGroupPattern = false;
    this._value._groupPattern = null;
    return this;
  }
  setUnitType(value) {
    this._value._hasUnitType = true;
    this._value._unitType = value;
    return this;
  }
  deleteUnitType() {
    this._value._hasUnitType = false;
    this._value._unitType = null;
    return this;
  }
  setPatternName(value) {
    this._value._hasPatternName = true;
    this._value._patternName = value;
    return this;
  }
  deletePatternName() {
    this._value._hasPatternName = false;
    this._value._patternName = null;
    return this;
  }
  setCount(value) {
    this._value._hasCount = true;
    this._value._count = value;
    return this;
  }
  deleteCount() {
    this._value._hasCount = false;
    this._value._count = null;
    return this;
  }
  setInitialDelay(value) {
    this._value._hasInitialDelay = true;
    this._value._initialDelay = value;
    return this;
  }
  deleteInitialDelay() {
    this._value._hasInitialDelay = false;
    this._value._initialDelay = null;
    return this;
  }
  addAllYieldGroup(values) {
    this._value._yieldGroup = this._value._yieldGroup.concat(values);
    return this;
  }
  addYieldGroup(value) {
    this._value._yieldGroup = this._value._yieldGroup.concat([value]);
    return this;
  }
  setYieldGroup(index, value) {
    this._value._yieldGroup = this._value._yieldGroup.concat();
    this._value._yieldGroup[index] = value;
    return this;
  }
  clearYieldGroup() {
    this._value._yieldGroup = [];
    return this;
  }
}
SubWave.Builder = SubWave_Builder;
class SubWave_WithParent {
  /**
   * @param {SubWave} value
   * @param {SubWave_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return SubWave.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasName() {
    if (this._cachedHasName === undefined) {
      if (this._value.hasName) {
        this._cachedHasName = true;
      } else {
        this._cachedHasName = this._parent ? this._parent.hasName : false;
      }
    }
    return this._cachedHasName;
  }
  get name() {
    if (this._cachedName === undefined) {
      if (this._value.hasName) {
        this._cachedName = this._value.name;
      } else {
        this._cachedName = this._parent ? this._parent.name : this._value.name;
      }
    }
    return this._cachedName;
  }
  get hasNote() {
    if (this._cachedHasNote === undefined) {
      if (this._value.hasNote) {
        this._cachedHasNote = true;
      } else {
        this._cachedHasNote = this._parent ? this._parent.hasNote : false;
      }
    }
    return this._cachedHasNote;
  }
  get note() {
    if (this._cachedNote === undefined) {
      if (this._value.hasNote) {
        this._cachedNote = this._value.note;
      } else {
        this._cachedNote = this._parent ? this._parent.note : this._value.note;
      }
    }
    return this._cachedNote;
  }
  get hasGroupPattern() {
    if (this._cachedHasGroupPattern === undefined) {
      if (this._value.hasGroupPattern) {
        this._cachedHasGroupPattern = true;
      } else {
        this._cachedHasGroupPattern = this._parent ? this._parent.hasGroupPattern : false;
      }
    }
    return this._cachedHasGroupPattern;
  }
  get groupPattern() {
    if (this._cachedGroupPattern === undefined) {
      if (this._value.hasGroupPattern) {
        this._cachedGroupPattern = this._value.groupPattern;
      } else {
        this._cachedGroupPattern = this._parent ? this._parent.groupPattern : this._value.groupPattern;
      }
    }
    return this._cachedGroupPattern;
  }
  get hasUnitType() {
    if (this._cachedHasUnitType === undefined) {
      if (this._value.hasUnitType) {
        this._cachedHasUnitType = true;
      } else {
        this._cachedHasUnitType = this._parent ? this._parent.hasUnitType : false;
      }
    }
    return this._cachedHasUnitType;
  }
  get unitType() {
    if (this._cachedUnitType === undefined) {
      if (this._value.hasUnitType) {
        this._cachedUnitType = this._value.unitType;
      } else {
        this._cachedUnitType = this._parent ? this._parent.unitType : this._value.unitType;
      }
    }
    return this._cachedUnitType;
  }
  get hasPatternName() {
    if (this._cachedHasPatternName === undefined) {
      if (this._value.hasPatternName) {
        this._cachedHasPatternName = true;
      } else {
        this._cachedHasPatternName = this._parent ? this._parent.hasPatternName : false;
      }
    }
    return this._cachedHasPatternName;
  }
  get patternName() {
    if (this._cachedPatternName === undefined) {
      if (this._value.hasPatternName) {
        this._cachedPatternName = this._value.patternName;
      } else {
        this._cachedPatternName = this._parent ? this._parent.patternName : this._value.patternName;
      }
    }
    return this._cachedPatternName;
  }
  get hasCount() {
    if (this._cachedHasCount === undefined) {
      if (this._value.hasCount) {
        this._cachedHasCount = true;
      } else {
        this._cachedHasCount = this._parent ? this._parent.hasCount : false;
      }
    }
    return this._cachedHasCount;
  }
  get count() {
    if (this._cachedCount === undefined) {
      if (this._value.hasCount) {
        this._cachedCount = this._value.count;
      } else {
        this._cachedCount = this._parent ? this._parent.count : this._value.count;
      }
    }
    return this._cachedCount;
  }
  get hasInitialDelay() {
    if (this._cachedHasInitialDelay === undefined) {
      if (this._value.hasInitialDelay) {
        this._cachedHasInitialDelay = true;
      } else {
        this._cachedHasInitialDelay = this._parent ? this._parent.hasInitialDelay : false;
      }
    }
    return this._cachedHasInitialDelay;
  }
  get initialDelay() {
    if (this._cachedInitialDelay === undefined) {
      if (this._value.hasInitialDelay) {
        this._cachedInitialDelay = this._value.initialDelay;
      } else {
        this._cachedInitialDelay = this._parent ? this._parent.initialDelay : this._value.initialDelay;
      }
    }
    return this._cachedInitialDelay;
  }
  get selfYieldGroup() {
    return this._value.yieldGroup;
  }
  get inherentYieldGroup() {
    if (!this._inherentYieldGroup) {
      this._inherentYieldGroup = this._parent ? this._parent.yieldGroup : [];
    }
    return this._inherentYieldGroup;
  }
  get yieldGroup() {
    if (!this._allYieldGroup) {
      this._allYieldGroup = this._parent ? this._parent.yieldGroup.concat(this.selfYieldGroup) : this.selfYieldGroup;
    }
    return this._allYieldGroup;
  }
  update(current, parent) {
    const result = new SubWave_WithParent(current, parent);
    return result;
  }
}
SubWave_WithParent.default = new SubWave_WithParent(SubWave.default, null);
SubWave.WithParent = SubWave_WithParent;
class SubWave_Descriptor {
  get name() {
    if (!this._name) {
      this._name = {
        name: "name",
        Name: "Name",
        number: 1,
        protoType: 9,
        protoName: "name",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._name;
  }
  get note() {
    if (!this._note) {
      this._note = {
        name: "note",
        Name: "Note",
        number: 2,
        protoType: 9,
        protoName: "note",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._note;
  }
  get groupPattern() {
    if (!this._groupPattern) {
      this._groupPattern = {
        name: "groupPattern",
        Name: "GroupPattern",
        number: 3,
        protoType: 9,
        protoName: "group_pattern",
        type: JsonToString,
        options: {
          valueDropdown: "SupportedSpawnPatternGroupNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._groupPattern;
  }
  get unitType() {
    if (!this._unitType) {
      this._unitType = {
        name: "unitType",
        Name: "UnitType",
        number: 4,
        protoType: 9,
        protoName: "unit_type",
        type: JsonToString,
        options: {
          valueDropdown: "SupportedBaseUnitNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._unitType;
  }
  get patternName() {
    if (!this._patternName) {
      this._patternName = {
        name: "patternName",
        Name: "PatternName",
        number: 5,
        protoType: 9,
        protoName: "pattern_name",
        type: JsonToString,
        options: {
          valueDropdown: "SupportedSpawnPatternListNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._patternName;
  }
  get count() {
    if (!this._count) {
      this._count = {
        name: "count",
        Name: "Count",
        number: 6,
        protoType: 5,
        protoName: "count",
        type: JsonToInt32,
        options: {
          min: 0,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._count;
  }
  get initialDelay() {
    if (!this._initialDelay) {
      this._initialDelay = {
        name: "initialDelay",
        Name: "InitialDelay",
        number: 7,
        protoType: 1,
        protoName: "initial_delay",
        type: JsonToDouble,
        options: {
          min: 0,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._initialDelay;
  }
  get yieldGroup() {
    if (!this._yieldGroup) {
      this._yieldGroup = {
        name: "yieldGroup",
        Name: "YieldGroup",
        number: 8,
        protoType: 9,
        protoName: "yield_group",
        type: JsonToString,
        isRepeated: true,
        options: {
          valueDropdown: "SupportedYieldGroupNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._yieldGroup;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.name,
        this.note,
        this.groupPattern,
        this.unitType,
        this.patternName,
        this.count,
        this.initialDelay,
        this.yieldGroup,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForName",
        Name: "DummyOneofForName",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForNote",
        Name: "DummyOneofForNote",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForGroupPattern",
        Name: "DummyOneofForGroupPattern",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForUnitType",
        Name: "DummyOneofForUnitType",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForPatternName",
        Name: "DummyOneofForPatternName",
        fields: [
          this.fields[4],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCount",
        Name: "DummyOneofForCount",
        fields: [
          this.fields[5],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForInitialDelay",
        Name: "DummyOneofForInitialDelay",
        fields: [
          this.fields[6],
        ],
      });
    }
    return this._oneofs;
  }
}
SubWave.descriptor = new SubWave_Descriptor();
class CameraSettings_ViewMode {
  static fromJson(json) {
    if (typeof json === "string") {
      switch (json) {
        case "DEFAULT": return 0;
        case "ORTHOGRAPHIC_ONLY": return 1;
        case "PERSPECTIVE_ONLY": return 2;
        default: return 0;
      }
    }
    return json;
  }
  static toJson(value) {
    return value;
  }
  static fromAny(value) {
    return CameraSettings_ViewMode.fromJson(value);
  }
  static fromReact(e) {
    return CameraSettings_ViewMode.fromJson(e);
  }
}
CameraSettings_ViewMode.DEFAULT = 0;
CameraSettings_ViewMode.ORTHOGRAPHIC_ONLY = 1;
CameraSettings_ViewMode.PERSPECTIVE_ONLY = 2;
CameraSettings_ViewMode.default = 0;
CameraSettings_ViewMode.values = {
  DEFAULT: 0,
  ORTHOGRAPHIC_ONLY: 1,
  PERSPECTIVE_ONLY: 2,
};
CameraSettings_ViewMode.names = {
  0: "DEFAULT",
  1: "ORTHOGRAPHIC_ONLY",
  2: "PERSPECTIVE_ONLY",
};
export class CameraSettings {
  get descriptor() {
    return CameraSettings.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasFocalPointX = false;
    this._focalPointX = null;
    this._hasFocalPointY = false;
    this._focalPointY = null;
    this._hasPitchAngleDegree = false;
    this._pitchAngleDegree = null;
    this._hasAllowZoom = false;
    this._allowZoom = null;
    this._hasAllowPanX = false;
    this._allowPanX = null;
    this._hasAllowPanY = false;
    this._allowPanY = null;
    this._hasPanAreaCenterX = false;
    this._panAreaCenterX = null;
    this._hasPanAreaCenterY = false;
    this._panAreaCenterY = null;
    this._hasPanAreaLengthX = false;
    this._panAreaLengthX = null;
    this._hasPanAreaHeightY = false;
    this._panAreaHeightY = null;
    this._hasSkipIntroSequence = false;
    this._skipIntroSequence = null;
    this._hasViewMode = false;
    this._viewMode = null;
  }
  isEmpty() {
    if (this._hasFocalPointX) return false;
    if (this._hasFocalPointY) return false;
    if (this._hasPitchAngleDegree) return false;
    if (this._hasAllowZoom) return false;
    if (this._hasAllowPanX) return false;
    if (this._hasAllowPanY) return false;
    if (this._hasPanAreaCenterX) return false;
    if (this._hasPanAreaCenterY) return false;
    if (this._hasPanAreaLengthX) return false;
    if (this._hasPanAreaHeightY) return false;
    if (this._hasSkipIntroSequence) return false;
    if (this._hasViewMode) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof CameraSettings) {
      return value;
    }
    return CameraSettings.fromJson(value);
  }
  static fromJson(json) {
    const result = new CameraSettings();
    if (json.focalPointX != null) {
      result._hasFocalPointX = true;
      result._focalPointX = JsonToDouble.fromJson(json.focalPointX);
    }
    if (json.focalPointY != null) {
      result._hasFocalPointY = true;
      result._focalPointY = JsonToDouble.fromJson(json.focalPointY);
    }
    if (json.pitchAngleDegree != null) {
      result._hasPitchAngleDegree = true;
      result._pitchAngleDegree = JsonToDouble.fromJson(json.pitchAngleDegree);
    }
    if (json.allowZoom != null) {
      result._hasAllowZoom = true;
      result._allowZoom = JsonToBoolean.fromJson(json.allowZoom);
    }
    if (json.allowPanX != null) {
      result._hasAllowPanX = true;
      result._allowPanX = JsonToBoolean.fromJson(json.allowPanX);
    }
    if (json.allowPanY != null) {
      result._hasAllowPanY = true;
      result._allowPanY = JsonToBoolean.fromJson(json.allowPanY);
    }
    if (json.panAreaCenterX != null) {
      result._hasPanAreaCenterX = true;
      result._panAreaCenterX = JsonToDouble.fromJson(json.panAreaCenterX);
    }
    if (json.panAreaCenterY != null) {
      result._hasPanAreaCenterY = true;
      result._panAreaCenterY = JsonToDouble.fromJson(json.panAreaCenterY);
    }
    if (json.panAreaLengthX != null) {
      result._hasPanAreaLengthX = true;
      result._panAreaLengthX = JsonToDouble.fromJson(json.panAreaLengthX);
    }
    if (json.panAreaHeightY != null) {
      result._hasPanAreaHeightY = true;
      result._panAreaHeightY = JsonToDouble.fromJson(json.panAreaHeightY);
    }
    if (json.skipIntroSequence != null) {
      result._hasSkipIntroSequence = true;
      result._skipIntroSequence = JsonToBoolean.fromJson(json.skipIntroSequence);
    }
    if (json.viewMode != null) {
      result._hasViewMode = true;
      result._viewMode = CameraSettings_ViewMode.fromJson(json.viewMode);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasFocalPointX) {
      result.focalPointX = JsonToDouble.toJson(this._focalPointX);
    }
    if (this._hasFocalPointY) {
      result.focalPointY = JsonToDouble.toJson(this._focalPointY);
    }
    if (this._hasPitchAngleDegree) {
      result.pitchAngleDegree = JsonToDouble.toJson(this._pitchAngleDegree);
    }
    if (this._hasAllowZoom) {
      result.allowZoom = JsonToBoolean.toJson(this._allowZoom);
    }
    if (this._hasAllowPanX) {
      result.allowPanX = JsonToBoolean.toJson(this._allowPanX);
    }
    if (this._hasAllowPanY) {
      result.allowPanY = JsonToBoolean.toJson(this._allowPanY);
    }
    if (this._hasPanAreaCenterX) {
      result.panAreaCenterX = JsonToDouble.toJson(this._panAreaCenterX);
    }
    if (this._hasPanAreaCenterY) {
      result.panAreaCenterY = JsonToDouble.toJson(this._panAreaCenterY);
    }
    if (this._hasPanAreaLengthX) {
      result.panAreaLengthX = JsonToDouble.toJson(this._panAreaLengthX);
    }
    if (this._hasPanAreaHeightY) {
      result.panAreaHeightY = JsonToDouble.toJson(this._panAreaHeightY);
    }
    if (this._hasSkipIntroSequence) {
      result.skipIntroSequence = JsonToBoolean.toJson(this._skipIntroSequence);
    }
    if (this._hasViewMode) {
      result.viewMode = CameraSettings_ViewMode.toJson(this._viewMode);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get focalPointX() {
    return this._hasFocalPointX ? this._focalPointX : JsonToDouble.default;
  }
  get hasFocalPointX() {
    return this._hasFocalPointX;
  }
  setFocalPointX(path, value) {
    return {type: 'SET', path: path.concat(['focalPointX']), value};
  }
  deleteFocalPointX(path) {
    return {type: 'DELETE', path: path.concat(['focalPointX'])};
  }
  /**
   * @returns {number}
   */
  get focalPointY() {
    return this._hasFocalPointY ? this._focalPointY : JsonToDouble.default;
  }
  get hasFocalPointY() {
    return this._hasFocalPointY;
  }
  setFocalPointY(path, value) {
    return {type: 'SET', path: path.concat(['focalPointY']), value};
  }
  deleteFocalPointY(path) {
    return {type: 'DELETE', path: path.concat(['focalPointY'])};
  }
  /**
   * @returns {number}
   */
  get pitchAngleDegree() {
    return this._hasPitchAngleDegree ? this._pitchAngleDegree : JsonToDouble.default;
  }
  get hasPitchAngleDegree() {
    return this._hasPitchAngleDegree;
  }
  setPitchAngleDegree(path, value) {
    return {type: 'SET', path: path.concat(['pitchAngleDegree']), value};
  }
  deletePitchAngleDegree(path) {
    return {type: 'DELETE', path: path.concat(['pitchAngleDegree'])};
  }
  /**
   * @returns {boolean}
   */
  get allowZoom() {
    return this._hasAllowZoom ? this._allowZoom : JsonToBoolean.default;
  }
  get hasAllowZoom() {
    return this._hasAllowZoom;
  }
  setAllowZoom(path, value) {
    return {type: 'SET', path: path.concat(['allowZoom']), value};
  }
  deleteAllowZoom(path) {
    return {type: 'DELETE', path: path.concat(['allowZoom'])};
  }
  /**
   * @returns {boolean}
   */
  get allowPanX() {
    return this._hasAllowPanX ? this._allowPanX : JsonToBoolean.default;
  }
  get hasAllowPanX() {
    return this._hasAllowPanX;
  }
  setAllowPanX(path, value) {
    return {type: 'SET', path: path.concat(['allowPanX']), value};
  }
  deleteAllowPanX(path) {
    return {type: 'DELETE', path: path.concat(['allowPanX'])};
  }
  /**
   * @returns {boolean}
   */
  get allowPanY() {
    return this._hasAllowPanY ? this._allowPanY : JsonToBoolean.default;
  }
  get hasAllowPanY() {
    return this._hasAllowPanY;
  }
  setAllowPanY(path, value) {
    return {type: 'SET', path: path.concat(['allowPanY']), value};
  }
  deleteAllowPanY(path) {
    return {type: 'DELETE', path: path.concat(['allowPanY'])};
  }
  /**
   * @returns {number}
   */
  get panAreaCenterX() {
    return this._hasPanAreaCenterX ? this._panAreaCenterX : JsonToDouble.default;
  }
  get hasPanAreaCenterX() {
    return this._hasPanAreaCenterX;
  }
  setPanAreaCenterX(path, value) {
    return {type: 'SET', path: path.concat(['panAreaCenterX']), value};
  }
  deletePanAreaCenterX(path) {
    return {type: 'DELETE', path: path.concat(['panAreaCenterX'])};
  }
  /**
   * @returns {number}
   */
  get panAreaCenterY() {
    return this._hasPanAreaCenterY ? this._panAreaCenterY : JsonToDouble.default;
  }
  get hasPanAreaCenterY() {
    return this._hasPanAreaCenterY;
  }
  setPanAreaCenterY(path, value) {
    return {type: 'SET', path: path.concat(['panAreaCenterY']), value};
  }
  deletePanAreaCenterY(path) {
    return {type: 'DELETE', path: path.concat(['panAreaCenterY'])};
  }
  /**
   * @returns {number}
   */
  get panAreaLengthX() {
    return this._hasPanAreaLengthX ? this._panAreaLengthX : JsonToDouble.default;
  }
  get hasPanAreaLengthX() {
    return this._hasPanAreaLengthX;
  }
  setPanAreaLengthX(path, value) {
    return {type: 'SET', path: path.concat(['panAreaLengthX']), value};
  }
  deletePanAreaLengthX(path) {
    return {type: 'DELETE', path: path.concat(['panAreaLengthX'])};
  }
  /**
   * @returns {number}
   */
  get panAreaHeightY() {
    return this._hasPanAreaHeightY ? this._panAreaHeightY : JsonToDouble.default;
  }
  get hasPanAreaHeightY() {
    return this._hasPanAreaHeightY;
  }
  setPanAreaHeightY(path, value) {
    return {type: 'SET', path: path.concat(['panAreaHeightY']), value};
  }
  deletePanAreaHeightY(path) {
    return {type: 'DELETE', path: path.concat(['panAreaHeightY'])};
  }
  /**
   * @returns {boolean}
   */
  get skipIntroSequence() {
    return this._hasSkipIntroSequence ? this._skipIntroSequence : JsonToBoolean.default;
  }
  get hasSkipIntroSequence() {
    return this._hasSkipIntroSequence;
  }
  setSkipIntroSequence(path, value) {
    return {type: 'SET', path: path.concat(['skipIntroSequence']), value};
  }
  deleteSkipIntroSequence(path) {
    return {type: 'DELETE', path: path.concat(['skipIntroSequence'])};
  }
  /**
   * @returns {number}
   */
  get viewMode() {
    return this._hasViewMode ? this._viewMode : CameraSettings_ViewMode.default;
  }
  get hasViewMode() {
    return this._hasViewMode;
  }
  setViewMode(path, value) {
    return {type: 'SET', path: path.concat(['viewMode']), value};
  }
  deleteViewMode(path) {
    return {type: 'DELETE', path: path.concat(['viewMode'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "focalPointX": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CameraSettings(this);
              copy._hasFocalPointX = true;
              copy._focalPointX = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasFocalPointX) {
                return this;
              }
              const copy = new CameraSettings(this);
              copy._hasFocalPointX = false;
              copy._focalPointX = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "focalPointY": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CameraSettings(this);
              copy._hasFocalPointY = true;
              copy._focalPointY = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasFocalPointY) {
                return this;
              }
              const copy = new CameraSettings(this);
              copy._hasFocalPointY = false;
              copy._focalPointY = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "pitchAngleDegree": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CameraSettings(this);
              copy._hasPitchAngleDegree = true;
              copy._pitchAngleDegree = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPitchAngleDegree) {
                return this;
              }
              const copy = new CameraSettings(this);
              copy._hasPitchAngleDegree = false;
              copy._pitchAngleDegree = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "allowZoom": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CameraSettings(this);
              copy._hasAllowZoom = true;
              copy._allowZoom = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAllowZoom) {
                return this;
              }
              const copy = new CameraSettings(this);
              copy._hasAllowZoom = false;
              copy._allowZoom = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "allowPanX": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CameraSettings(this);
              copy._hasAllowPanX = true;
              copy._allowPanX = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAllowPanX) {
                return this;
              }
              const copy = new CameraSettings(this);
              copy._hasAllowPanX = false;
              copy._allowPanX = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "allowPanY": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CameraSettings(this);
              copy._hasAllowPanY = true;
              copy._allowPanY = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAllowPanY) {
                return this;
              }
              const copy = new CameraSettings(this);
              copy._hasAllowPanY = false;
              copy._allowPanY = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "panAreaCenterX": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CameraSettings(this);
              copy._hasPanAreaCenterX = true;
              copy._panAreaCenterX = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPanAreaCenterX) {
                return this;
              }
              const copy = new CameraSettings(this);
              copy._hasPanAreaCenterX = false;
              copy._panAreaCenterX = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "panAreaCenterY": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CameraSettings(this);
              copy._hasPanAreaCenterY = true;
              copy._panAreaCenterY = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPanAreaCenterY) {
                return this;
              }
              const copy = new CameraSettings(this);
              copy._hasPanAreaCenterY = false;
              copy._panAreaCenterY = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "panAreaLengthX": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CameraSettings(this);
              copy._hasPanAreaLengthX = true;
              copy._panAreaLengthX = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPanAreaLengthX) {
                return this;
              }
              const copy = new CameraSettings(this);
              copy._hasPanAreaLengthX = false;
              copy._panAreaLengthX = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "panAreaHeightY": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CameraSettings(this);
              copy._hasPanAreaHeightY = true;
              copy._panAreaHeightY = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPanAreaHeightY) {
                return this;
              }
              const copy = new CameraSettings(this);
              copy._hasPanAreaHeightY = false;
              copy._panAreaHeightY = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "skipIntroSequence": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CameraSettings(this);
              copy._hasSkipIntroSequence = true;
              copy._skipIntroSequence = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSkipIntroSequence) {
                return this;
              }
              const copy = new CameraSettings(this);
              copy._hasSkipIntroSequence = false;
              copy._skipIntroSequence = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "viewMode": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CameraSettings(this);
              copy._hasViewMode = true;
              copy._viewMode = CameraSettings_ViewMode.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasViewMode) {
                return this;
              }
              const copy = new CameraSettings(this);
              copy._hasViewMode = false;
              copy._viewMode = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {CameraSettings} other
   * @returns {CameraSettings}
   */
  merge(other) {
    const copy = new CameraSettings(this);
    if (other._hasFocalPointX) {
      copy._hasFocalPointX = true;
      copy._focalPointX = other._focalPointX;
    }
    if (other._hasFocalPointY) {
      copy._hasFocalPointY = true;
      copy._focalPointY = other._focalPointY;
    }
    if (other._hasPitchAngleDegree) {
      copy._hasPitchAngleDegree = true;
      copy._pitchAngleDegree = other._pitchAngleDegree;
    }
    if (other._hasAllowZoom) {
      copy._hasAllowZoom = true;
      copy._allowZoom = other._allowZoom;
    }
    if (other._hasAllowPanX) {
      copy._hasAllowPanX = true;
      copy._allowPanX = other._allowPanX;
    }
    if (other._hasAllowPanY) {
      copy._hasAllowPanY = true;
      copy._allowPanY = other._allowPanY;
    }
    if (other._hasPanAreaCenterX) {
      copy._hasPanAreaCenterX = true;
      copy._panAreaCenterX = other._panAreaCenterX;
    }
    if (other._hasPanAreaCenterY) {
      copy._hasPanAreaCenterY = true;
      copy._panAreaCenterY = other._panAreaCenterY;
    }
    if (other._hasPanAreaLengthX) {
      copy._hasPanAreaLengthX = true;
      copy._panAreaLengthX = other._panAreaLengthX;
    }
    if (other._hasPanAreaHeightY) {
      copy._hasPanAreaHeightY = true;
      copy._panAreaHeightY = other._panAreaHeightY;
    }
    if (other._hasSkipIntroSequence) {
      copy._hasSkipIntroSequence = true;
      copy._skipIntroSequence = other._skipIntroSequence;
    }
    if (other._hasViewMode) {
      copy._hasViewMode = true;
      copy._viewMode = other._viewMode;
    }
    return copy;
  }
}
CameraSettings.default = new CameraSettings();
CameraSettings.ViewMode = CameraSettings_ViewMode;
class CameraSettings_Builder {
  constructor(value) {
    this._value = new CameraSettings(value);
  }
  build() {
    return new CameraSettings(this._value);
  }
  setFocalPointX(value) {
    this._value._hasFocalPointX = true;
    this._value._focalPointX = value;
    return this;
  }
  deleteFocalPointX() {
    this._value._hasFocalPointX = false;
    this._value._focalPointX = null;
    return this;
  }
  setFocalPointY(value) {
    this._value._hasFocalPointY = true;
    this._value._focalPointY = value;
    return this;
  }
  deleteFocalPointY() {
    this._value._hasFocalPointY = false;
    this._value._focalPointY = null;
    return this;
  }
  setPitchAngleDegree(value) {
    this._value._hasPitchAngleDegree = true;
    this._value._pitchAngleDegree = value;
    return this;
  }
  deletePitchAngleDegree() {
    this._value._hasPitchAngleDegree = false;
    this._value._pitchAngleDegree = null;
    return this;
  }
  setAllowZoom(value) {
    this._value._hasAllowZoom = true;
    this._value._allowZoom = value;
    return this;
  }
  deleteAllowZoom() {
    this._value._hasAllowZoom = false;
    this._value._allowZoom = null;
    return this;
  }
  setAllowPanX(value) {
    this._value._hasAllowPanX = true;
    this._value._allowPanX = value;
    return this;
  }
  deleteAllowPanX() {
    this._value._hasAllowPanX = false;
    this._value._allowPanX = null;
    return this;
  }
  setAllowPanY(value) {
    this._value._hasAllowPanY = true;
    this._value._allowPanY = value;
    return this;
  }
  deleteAllowPanY() {
    this._value._hasAllowPanY = false;
    this._value._allowPanY = null;
    return this;
  }
  setPanAreaCenterX(value) {
    this._value._hasPanAreaCenterX = true;
    this._value._panAreaCenterX = value;
    return this;
  }
  deletePanAreaCenterX() {
    this._value._hasPanAreaCenterX = false;
    this._value._panAreaCenterX = null;
    return this;
  }
  setPanAreaCenterY(value) {
    this._value._hasPanAreaCenterY = true;
    this._value._panAreaCenterY = value;
    return this;
  }
  deletePanAreaCenterY() {
    this._value._hasPanAreaCenterY = false;
    this._value._panAreaCenterY = null;
    return this;
  }
  setPanAreaLengthX(value) {
    this._value._hasPanAreaLengthX = true;
    this._value._panAreaLengthX = value;
    return this;
  }
  deletePanAreaLengthX() {
    this._value._hasPanAreaLengthX = false;
    this._value._panAreaLengthX = null;
    return this;
  }
  setPanAreaHeightY(value) {
    this._value._hasPanAreaHeightY = true;
    this._value._panAreaHeightY = value;
    return this;
  }
  deletePanAreaHeightY() {
    this._value._hasPanAreaHeightY = false;
    this._value._panAreaHeightY = null;
    return this;
  }
  setSkipIntroSequence(value) {
    this._value._hasSkipIntroSequence = true;
    this._value._skipIntroSequence = value;
    return this;
  }
  deleteSkipIntroSequence() {
    this._value._hasSkipIntroSequence = false;
    this._value._skipIntroSequence = null;
    return this;
  }
  setViewMode(value) {
    this._value._hasViewMode = true;
    this._value._viewMode = value;
    return this;
  }
  deleteViewMode() {
    this._value._hasViewMode = false;
    this._value._viewMode = null;
    return this;
  }
}
CameraSettings.Builder = CameraSettings_Builder;
class CameraSettings_WithParent {
  /**
   * @param {CameraSettings} value
   * @param {CameraSettings_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return CameraSettings.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasFocalPointX() {
    if (this._cachedHasFocalPointX === undefined) {
      if (this._value.hasFocalPointX) {
        this._cachedHasFocalPointX = true;
      } else {
        this._cachedHasFocalPointX = this._parent ? this._parent.hasFocalPointX : false;
      }
    }
    return this._cachedHasFocalPointX;
  }
  get focalPointX() {
    if (this._cachedFocalPointX === undefined) {
      if (this._value.hasFocalPointX) {
        this._cachedFocalPointX = this._value.focalPointX;
      } else {
        this._cachedFocalPointX = this._parent ? this._parent.focalPointX : this._value.focalPointX;
      }
    }
    return this._cachedFocalPointX;
  }
  get hasFocalPointY() {
    if (this._cachedHasFocalPointY === undefined) {
      if (this._value.hasFocalPointY) {
        this._cachedHasFocalPointY = true;
      } else {
        this._cachedHasFocalPointY = this._parent ? this._parent.hasFocalPointY : false;
      }
    }
    return this._cachedHasFocalPointY;
  }
  get focalPointY() {
    if (this._cachedFocalPointY === undefined) {
      if (this._value.hasFocalPointY) {
        this._cachedFocalPointY = this._value.focalPointY;
      } else {
        this._cachedFocalPointY = this._parent ? this._parent.focalPointY : this._value.focalPointY;
      }
    }
    return this._cachedFocalPointY;
  }
  get hasPitchAngleDegree() {
    if (this._cachedHasPitchAngleDegree === undefined) {
      if (this._value.hasPitchAngleDegree) {
        this._cachedHasPitchAngleDegree = true;
      } else {
        this._cachedHasPitchAngleDegree = this._parent ? this._parent.hasPitchAngleDegree : false;
      }
    }
    return this._cachedHasPitchAngleDegree;
  }
  get pitchAngleDegree() {
    if (this._cachedPitchAngleDegree === undefined) {
      if (this._value.hasPitchAngleDegree) {
        this._cachedPitchAngleDegree = this._value.pitchAngleDegree;
      } else {
        this._cachedPitchAngleDegree = this._parent ? this._parent.pitchAngleDegree : this._value.pitchAngleDegree;
      }
    }
    return this._cachedPitchAngleDegree;
  }
  get hasAllowZoom() {
    if (this._cachedHasAllowZoom === undefined) {
      if (this._value.hasAllowZoom) {
        this._cachedHasAllowZoom = true;
      } else {
        this._cachedHasAllowZoom = this._parent ? this._parent.hasAllowZoom : false;
      }
    }
    return this._cachedHasAllowZoom;
  }
  get allowZoom() {
    if (this._cachedAllowZoom === undefined) {
      if (this._value.hasAllowZoom) {
        this._cachedAllowZoom = this._value.allowZoom;
      } else {
        this._cachedAllowZoom = this._parent ? this._parent.allowZoom : this._value.allowZoom;
      }
    }
    return this._cachedAllowZoom;
  }
  get hasAllowPanX() {
    if (this._cachedHasAllowPanX === undefined) {
      if (this._value.hasAllowPanX) {
        this._cachedHasAllowPanX = true;
      } else {
        this._cachedHasAllowPanX = this._parent ? this._parent.hasAllowPanX : false;
      }
    }
    return this._cachedHasAllowPanX;
  }
  get allowPanX() {
    if (this._cachedAllowPanX === undefined) {
      if (this._value.hasAllowPanX) {
        this._cachedAllowPanX = this._value.allowPanX;
      } else {
        this._cachedAllowPanX = this._parent ? this._parent.allowPanX : this._value.allowPanX;
      }
    }
    return this._cachedAllowPanX;
  }
  get hasAllowPanY() {
    if (this._cachedHasAllowPanY === undefined) {
      if (this._value.hasAllowPanY) {
        this._cachedHasAllowPanY = true;
      } else {
        this._cachedHasAllowPanY = this._parent ? this._parent.hasAllowPanY : false;
      }
    }
    return this._cachedHasAllowPanY;
  }
  get allowPanY() {
    if (this._cachedAllowPanY === undefined) {
      if (this._value.hasAllowPanY) {
        this._cachedAllowPanY = this._value.allowPanY;
      } else {
        this._cachedAllowPanY = this._parent ? this._parent.allowPanY : this._value.allowPanY;
      }
    }
    return this._cachedAllowPanY;
  }
  get hasPanAreaCenterX() {
    if (this._cachedHasPanAreaCenterX === undefined) {
      if (this._value.hasPanAreaCenterX) {
        this._cachedHasPanAreaCenterX = true;
      } else {
        this._cachedHasPanAreaCenterX = this._parent ? this._parent.hasPanAreaCenterX : false;
      }
    }
    return this._cachedHasPanAreaCenterX;
  }
  get panAreaCenterX() {
    if (this._cachedPanAreaCenterX === undefined) {
      if (this._value.hasPanAreaCenterX) {
        this._cachedPanAreaCenterX = this._value.panAreaCenterX;
      } else {
        this._cachedPanAreaCenterX = this._parent ? this._parent.panAreaCenterX : this._value.panAreaCenterX;
      }
    }
    return this._cachedPanAreaCenterX;
  }
  get hasPanAreaCenterY() {
    if (this._cachedHasPanAreaCenterY === undefined) {
      if (this._value.hasPanAreaCenterY) {
        this._cachedHasPanAreaCenterY = true;
      } else {
        this._cachedHasPanAreaCenterY = this._parent ? this._parent.hasPanAreaCenterY : false;
      }
    }
    return this._cachedHasPanAreaCenterY;
  }
  get panAreaCenterY() {
    if (this._cachedPanAreaCenterY === undefined) {
      if (this._value.hasPanAreaCenterY) {
        this._cachedPanAreaCenterY = this._value.panAreaCenterY;
      } else {
        this._cachedPanAreaCenterY = this._parent ? this._parent.panAreaCenterY : this._value.panAreaCenterY;
      }
    }
    return this._cachedPanAreaCenterY;
  }
  get hasPanAreaLengthX() {
    if (this._cachedHasPanAreaLengthX === undefined) {
      if (this._value.hasPanAreaLengthX) {
        this._cachedHasPanAreaLengthX = true;
      } else {
        this._cachedHasPanAreaLengthX = this._parent ? this._parent.hasPanAreaLengthX : false;
      }
    }
    return this._cachedHasPanAreaLengthX;
  }
  get panAreaLengthX() {
    if (this._cachedPanAreaLengthX === undefined) {
      if (this._value.hasPanAreaLengthX) {
        this._cachedPanAreaLengthX = this._value.panAreaLengthX;
      } else {
        this._cachedPanAreaLengthX = this._parent ? this._parent.panAreaLengthX : this._value.panAreaLengthX;
      }
    }
    return this._cachedPanAreaLengthX;
  }
  get hasPanAreaHeightY() {
    if (this._cachedHasPanAreaHeightY === undefined) {
      if (this._value.hasPanAreaHeightY) {
        this._cachedHasPanAreaHeightY = true;
      } else {
        this._cachedHasPanAreaHeightY = this._parent ? this._parent.hasPanAreaHeightY : false;
      }
    }
    return this._cachedHasPanAreaHeightY;
  }
  get panAreaHeightY() {
    if (this._cachedPanAreaHeightY === undefined) {
      if (this._value.hasPanAreaHeightY) {
        this._cachedPanAreaHeightY = this._value.panAreaHeightY;
      } else {
        this._cachedPanAreaHeightY = this._parent ? this._parent.panAreaHeightY : this._value.panAreaHeightY;
      }
    }
    return this._cachedPanAreaHeightY;
  }
  get hasSkipIntroSequence() {
    if (this._cachedHasSkipIntroSequence === undefined) {
      if (this._value.hasSkipIntroSequence) {
        this._cachedHasSkipIntroSequence = true;
      } else {
        this._cachedHasSkipIntroSequence = this._parent ? this._parent.hasSkipIntroSequence : false;
      }
    }
    return this._cachedHasSkipIntroSequence;
  }
  get skipIntroSequence() {
    if (this._cachedSkipIntroSequence === undefined) {
      if (this._value.hasSkipIntroSequence) {
        this._cachedSkipIntroSequence = this._value.skipIntroSequence;
      } else {
        this._cachedSkipIntroSequence = this._parent ? this._parent.skipIntroSequence : this._value.skipIntroSequence;
      }
    }
    return this._cachedSkipIntroSequence;
  }
  get hasViewMode() {
    if (this._cachedHasViewMode === undefined) {
      if (this._value.hasViewMode) {
        this._cachedHasViewMode = true;
      } else {
        this._cachedHasViewMode = this._parent ? this._parent.hasViewMode : false;
      }
    }
    return this._cachedHasViewMode;
  }
  get viewMode() {
    if (this._cachedViewMode === undefined) {
      if (this._value.hasViewMode) {
        this._cachedViewMode = this._value.viewMode;
      } else {
        this._cachedViewMode = this._parent ? this._parent.viewMode : this._value.viewMode;
      }
    }
    return this._cachedViewMode;
  }
  update(current, parent) {
    const result = new CameraSettings_WithParent(current, parent);
    return result;
  }
}
CameraSettings_WithParent.default = new CameraSettings_WithParent(CameraSettings.default, null);
CameraSettings.WithParent = CameraSettings_WithParent;
class CameraSettings_Descriptor {
  get focalPointX() {
    if (!this._focalPointX) {
      this._focalPointX = {
        name: "focalPointX",
        Name: "FocalPointX",
        number: 1,
        protoType: 1,
        protoName: "focal_point_x",
        type: JsonToDouble,
        options: {
          comments: "Sets the starting X position of the camera.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._focalPointX;
  }
  get focalPointY() {
    if (!this._focalPointY) {
      this._focalPointY = {
        name: "focalPointY",
        Name: "FocalPointY",
        number: 2,
        protoType: 1,
        protoName: "focal_point_y",
        type: JsonToDouble,
        options: {
          comments: "Sets the starting Y position of the camera.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._focalPointY;
  }
  get pitchAngleDegree() {
    if (!this._pitchAngleDegree) {
      this._pitchAngleDegree = {
        name: "pitchAngleDegree",
        Name: "PitchAngleDegree",
        number: 5,
        protoType: 1,
        protoName: "pitch_angle_degree",
        type: JsonToDouble,
        options: {
          comments: "Sets the starting pitch angle of the camera.",
          default: 51,
          propertyRange: "1, 90",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._pitchAngleDegree;
  }
  get allowZoom() {
    if (!this._allowZoom) {
      this._allowZoom = {
        name: "allowZoom",
        Name: "AllowZoom",
        number: 20,
        protoType: 8,
        protoName: "allow_zoom",
        type: JsonToBoolean,
        options: {
          comments: "When checked, allows players to adjust camera zoom with mousewheel (PC) or pinch gestures (mobile).",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._allowZoom;
  }
  get allowPanX() {
    if (!this._allowPanX) {
      this._allowPanX = {
        name: "allowPanX",
        Name: "AllowPanX",
        number: 30,
        protoType: 8,
        protoName: "allow_pan_x",
        type: JsonToBoolean,
        options: {
          comments: "When checked, allows players to pan the camera horizontally within the map\'s pan area.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._allowPanX;
  }
  get allowPanY() {
    if (!this._allowPanY) {
      this._allowPanY = {
        name: "allowPanY",
        Name: "AllowPanY",
        number: 31,
        protoType: 8,
        protoName: "allow_pan_y",
        type: JsonToBoolean,
        options: {
          comments: "When checked, allows players to pan the camera vertically within the map\'s pan area.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._allowPanY;
  }
  get panAreaCenterX() {
    if (!this._panAreaCenterX) {
      this._panAreaCenterX = {
        name: "panAreaCenterX",
        Name: "PanAreaCenterX",
        number: 32,
        protoType: 1,
        protoName: "pan_area_center_x",
        type: JsonToDouble,
        options: {
          comments: "Sets the center X position of the allowed pannable area.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._panAreaCenterX;
  }
  get panAreaCenterY() {
    if (!this._panAreaCenterY) {
      this._panAreaCenterY = {
        name: "panAreaCenterY",
        Name: "PanAreaCenterY",
        number: 33,
        protoType: 1,
        protoName: "pan_area_center_y",
        type: JsonToDouble,
        options: {
          comments: "Sets the center Y position of the allowed pannable area.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._panAreaCenterY;
  }
  get panAreaLengthX() {
    if (!this._panAreaLengthX) {
      this._panAreaLengthX = {
        name: "panAreaLengthX",
        Name: "PanAreaLengthX",
        number: 34,
        protoType: 1,
        protoName: "pan_area_length_x",
        type: JsonToDouble,
        options: {
          comments: "Sets the horizontal width of the allowed pannable area.",
          min: 0,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._panAreaLengthX;
  }
  get panAreaHeightY() {
    if (!this._panAreaHeightY) {
      this._panAreaHeightY = {
        name: "panAreaHeightY",
        Name: "PanAreaHeightY",
        number: 37,
        protoType: 1,
        protoName: "pan_area_height_y",
        type: JsonToDouble,
        options: {
          comments: "Sets the vertical height of the allowed pannable area. Using 0 defaults to automatically setting an appropriate height for any given screen ratio.",
          default: "Automatic",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._panAreaHeightY;
  }
  get skipIntroSequence() {
    if (!this._skipIntroSequence) {
      this._skipIntroSequence = {
        name: "skipIntroSequence",
        Name: "SkipIntroSequence",
        number: 35,
        protoType: 8,
        protoName: "skip_intro_sequence",
        type: JsonToBoolean,
        options: {
          comments: "When checked, skips the camera zoom-in effect on map start.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._skipIntroSequence;
  }
  get viewMode() {
    if (!this._viewMode) {
      this._viewMode = {
        name: "viewMode",
        Name: "ViewMode",
        number: 36,
        protoType: 14,
        protoName: "view_mode",
        type: CameraSettings_ViewMode,
        options: {
          comments: "Sets the camera mode as perspective (default) or orthographic.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._viewMode;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.focalPointX,
        this.focalPointY,
        this.pitchAngleDegree,
        this.allowZoom,
        this.allowPanX,
        this.allowPanY,
        this.panAreaCenterX,
        this.panAreaCenterY,
        this.panAreaLengthX,
        this.panAreaHeightY,
        this.skipIntroSequence,
        this.viewMode,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForFocalPointX",
        Name: "DummyOneofForFocalPointX",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForFocalPointY",
        Name: "DummyOneofForFocalPointY",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForPitchAngleDegree",
        Name: "DummyOneofForPitchAngleDegree",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForAllowZoom",
        Name: "DummyOneofForAllowZoom",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForAllowPanX",
        Name: "DummyOneofForAllowPanX",
        fields: [
          this.fields[4],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForAllowPanY",
        Name: "DummyOneofForAllowPanY",
        fields: [
          this.fields[5],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForPanAreaCenterX",
        Name: "DummyOneofForPanAreaCenterX",
        fields: [
          this.fields[6],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForPanAreaCenterY",
        Name: "DummyOneofForPanAreaCenterY",
        fields: [
          this.fields[7],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForPanAreaLengthX",
        Name: "DummyOneofForPanAreaLengthX",
        fields: [
          this.fields[8],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForPanAreaHeightY",
        Name: "DummyOneofForPanAreaHeightY",
        fields: [
          this.fields[9],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForSkipIntroSequence",
        Name: "DummyOneofForSkipIntroSequence",
        fields: [
          this.fields[10],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForViewMode",
        Name: "DummyOneofForViewMode",
        fields: [
          this.fields[11],
        ],
      });
    }
    return this._oneofs;
  }
}
CameraSettings.descriptor = new CameraSettings_Descriptor();
